
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acee3", function(module, exports) {
$parcel$export(module.exports, "filterFieldsBySearchValue", function () { return (parcelRequire("6IEar")).filterFieldsBySearchValue; });
parcelRequire("6IEar");

});
parcelRegister("6IEar", function(module, exports) {

$parcel$export(module.exports, "filterFieldsBySearchValue", function () { return $67a79de605884d43$export$de29389d53f8108f; });
function $67a79de605884d43$export$de29389d53f8108f(fields, search) {
    if (!search) return true;
    return !!fields.filter((field)=>{
        if (!field) return false;
        return field.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase());
    }).length;
}

});


parcelRegister("bOBEI", function(module, exports) {
$parcel$export(module.exports, "WidgetLoadingState", function () { return (parcelRequire("77EIr")).WidgetLoadingState; });
parcelRequire("77EIr");

});
parcelRegister("77EIr", function(module, exports) {

$parcel$export(module.exports, "WidgetLoadingState", function () { return $32a5af37108dc44b$export$7e27a2e8e18ffe9b; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $3YfCm = parcelRequire("3YfCm");
const $32a5af37108dc44b$var$Header = (0, $akcQ4.default).div`
    width: 30%;
    height: 30px;
    border-radius: 8px;
`;
const $32a5af37108dc44b$var$Content = (0, $akcQ4.default).div`
    height: ${({ height: height })=>height ?? "100px"};
    border-radius: 8px;
`;
const $32a5af37108dc44b$var$Button = (0, $akcQ4.default).div`
    width: 130px;
    height: 40px;
    border-radius: 16px;
    &.sm {
        height: 30px;
    }
`;
const $32a5af37108dc44b$export$7e27a2e8e18ffe9b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function WidgetLoadingState({ title: title, headerButton: headerButton, height: height }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "widgetLoadingState",
        title: title ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Header, {
            className: "shimmer-container"
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Button, {
            className: "shimmer-container"
        }),
        ...headerButton && {
            headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Button, {
                className: "shimmer-container sm"
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Content, {
        className: "shimmer-container",
        height: height
    }));
});

});


parcelRegister("8MU0a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a315a598895bfcb1$export$2e2bcd8739ae039; });
var $a315a598895bfcb1$export$2e2bcd8739ae039 = (callback)=>(event)=>{
        event.preventDefault();
        return callback && callback(event);
    };

});

parcelRegister("9J2qy", function(module, exports) {
$parcel$export(module.exports, "MeasurementDeviceSearchListForm", function () { return (parcelRequire("fZJUc")).MeasurementDeviceSearchListForm; });
parcelRequire("fZJUc");

});
parcelRegister("fZJUc", function(module, exports) {

$parcel$export(module.exports, "MeasurementDeviceSearchListForm", function () { return $b3baf6f179c7f7a3$export$2e95fb6f6a74a034; });

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $8LupL = parcelRequire("8LupL");

var $1xw2Y = parcelRequire("1xw2Y");

var $4MH4b = parcelRequire("4MH4b");

var $aL1Vp = parcelRequire("aL1Vp");

var $aol72 = parcelRequire("aol72");
const $b3baf6f179c7f7a3$export$2e95fb6f6a74a034 = /*#__PURE__*/ (0, $6uMv9.memo)(function MeasurementDeviceSearchListForm({ clearDevice: clearDevice, onSubmit: onSubmit, loading: loading, style: style }) {
    const text = (0, $aL1Vp.default)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control } = (0, $cbVaW.useForm)();
    const statuses = [
        {
            value: "",
            label: text("lblAnyStatusOption")
        },
        {
            value: text("lblOffline"),
            label: text("lblOffline")
        },
        {
            value: text("lblOnline"),
            label: text("lblOnline")
        }
    ];
    const measurementDevicesProducts = [
        {
            value: "",
            label: text("lblAnyProductOption")
        },
        {
            value: 5,
            label: (0, $aol72.getProductName)(5)
        },
        {
            value: 8,
            label: (0, $aol72.getProductName)(8)
        },
        {
            value: 6,
            label: (0, $aol72.getProductName)(6)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        name: "form",
        role: "form",
        noValidate: true,
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblSerialNumber"),
        "data-testid": "input-serial",
        id: "deviceSerialNumber",
        key: "device SerialNumber",
        ...register("serialNumber")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblName"),
        "data-testid": "input-name",
        id: "deviceName",
        key: "device Name",
        ...register("name")
    })), !(0, $8LupL.isAdminDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblOrganisation"),
        "data-testid": "input-organisation",
        id: "deviceCompanyName",
        key: "device CompanyName",
        ...register("companyName")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblPartnerField"),
        "data-testid": "input-serial",
        id: "devicePartner",
        key: "device Partner",
        ...register("partnerName")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "status",
        control: control,
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "form-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("select", {
                title: "deviceStatus",
                name: "deviceStatus",
                className: "form-control",
                onChange: onChange,
                value: value ?? 0
            }, statuses.map((status, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("option", {
                    value: status.value,
                    key: index
                }, status.label))))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "productId",
        control: control,
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "form-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("select", {
                title: "deviceProduct",
                name: "deviceProduct",
                className: "form-control",
                onChange: onChange,
                value: value ?? 0
            }, measurementDevicesProducts.map((product, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("option", {
                    value: product.value,
                    key: index
                }, product.label))))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-4 pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok btn-sm",
        type: "submit"
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "fa fa-spinner fa-pulse",
        "data-testid": "btn-search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnSearch"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok btn-sm margin-2",
        type: "button",
        "data-testid": "btn-clear",
        onClick: ()=>{
            clearDevice();
            reset();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnClear"
    }))))))));
});

});
parcelRegister("4MH4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8ed20ab2e5771ff$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");
const $a8ed20ab2e5771ff$var$SearchInput = /*#__PURE__*/ (0, $6uMv9.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        ref: ref,
        type: "text",
        placeholder: props.placeholder,
        id: props.id,
        className: "form-control",
        value: props.value,
        name: props.name,
        ...props.onChange && {
            onChange: props.onChange
        },
        ...props.dataTestId && {
            "data-testid": props.dataTestId
        }
    })));
});
var $a8ed20ab2e5771ff$export$2e2bcd8739ae039 = $a8ed20ab2e5771ff$var$SearchInput;

});




var $6uMv9 = parcelRequire("6uMv9");

var $fXJGT = parcelRequire("fXJGT");

var $iZaUM = parcelRequire("iZaUM");

var $4vH3e = parcelRequire("4vH3e");

var $cFTyZ = parcelRequire("cFTyZ");

var $edR9j = parcelRequire("edR9j");

var $iQS7O = parcelRequire("iQS7O");

var $iAZE5 = parcelRequire("iAZE5");

var $dcOIZ = parcelRequire("dcOIZ");

var $3jZfA = parcelRequire("3jZfA");

var $atMtE = parcelRequire("atMtE");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $84v65 = parcelRequire("84v65");
var $iZaUM = parcelRequire("iZaUM");

var $73srW = parcelRequire("73srW");

var $8XNZy = parcelRequire("8XNZy");

var $2vwem = parcelRequire("2vwem");

var $4yml8 = parcelRequire("4yml8");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $7UisG = parcelRequire("7UisG");
function $9ef02355ab30dae0$var$SupportPageHeader({ className: className, style: style }) {
    const MENU_LINKS = [
        {
            href: "/dashboard",
            labelCode: "btnDashboard"
        },
        {
            href: "/chargepoints",
            labelCode: "btnChargers"
        },
        {
            href: "/partners",
            labelCode: "btnPartners"
        },
        {
            href: "/companies",
            labelCode: "btnOrganisations"
        },
        {
            href: "/users",
            labelCode: "btnUsers"
        },
        {
            href: "/firmware",
            labelCode: "btnFirmwareShort"
        },
        {
            href: "/loadbalancer",
            labelCode: "lblLoadbalancerGroups"
        },
        {
            href: "/measurementDevices",
            labelCode: "btnMeasurementDevices"
        },
        {
            href: "/operator-changes",
            labelCode: "btnOperatorChanges"
        },
        {
            labelCode: "btnIntegrations",
            subMenu: [
                {
                    href: "/eapi",
                    labelCode: "btnEapi"
                },
                {
                    href: "/externalservers",
                    labelCode: "btnProxyRelay"
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7UisG.PageHeader), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        links: MENU_LINKS
    });
}
var $9ef02355ab30dae0$export$2e2bcd8739ae039 = $9ef02355ab30dae0$var$SupportPageHeader;



var $6uMv9 = parcelRequire("6uMv9");

var $96Lrx = parcelRequire("96Lrx");

var $cfan9 = parcelRequire("cfan9");

var $8Mqhq = parcelRequire("8Mqhq");

var $lU1sx = parcelRequire("lU1sx");

var $52Dbq = parcelRequire("52Dbq");

var $iKfQu = parcelRequire("iKfQu");

var $fvmYM = parcelRequire("fvmYM");

var $6uMv9 = parcelRequire("6uMv9");

var $dpspD = parcelRequire("dpspD");

var $iZaUM = parcelRequire("iZaUM");

var $cFTyZ = parcelRequire("cFTyZ");

var $8RYO3 = parcelRequire("8RYO3");

var $fvmYM = parcelRequire("fvmYM");

var $8N7S6 = parcelRequire("8N7S6");

var $1oBYI = parcelRequire("1oBYI");

var $aL1Vp = parcelRequire("aL1Vp");
const $04f8dfdba5fdac3d$export$9fa80d37c94d77bd = ()=>{
    const text = (0, $aL1Vp.default)();
    const [searchFilter, setSearchFilter] = (0, $6uMv9.useState)("");
    const { data: latestErrors, isLoading: loadingErrors } = (0, $fvmYM.useLogGetErrorsQuery)({
        noOfItems: 100
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-column gap-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "error-search-input",
        type: "search",
        onChange: (e)=>setSearchFilter(e.target.value),
        placeholder: text("msgSearch"),
        icon: (0, $cFTyZ.PrimeIcons).SEARCH,
        name: "searchFilter",
        "data-testid": "error-search-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: latestErrors ?? [],
        size: "normal",
        removableSort: true,
        loading: loadingErrors,
        globalFilter: searchFilter,
        globalFilterFields: [
            "message"
        ],
        dataKey: "id",
        paginator: true,
        rows: 10,
        emptyMessage: text("msgNoErrorsFound"),
        "data-testid": "error-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "chargePointId",
        header: text("lblSerialNumber"),
        body: (log)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
                className: "pr-4",
                to: `/chargepoints/${log.chargePointId}`
            }, log.chargePointId);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "timestamp",
        header: text("lblTimestamp"),
        body: (latestError)=>(0, $8N7S6.dateLocalize)(latestError.timestamp)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "message",
        header: text("lblMessage"),
        className: "w-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "origin",
        header: text("lblOrigin")
    })));
};





var $4onjs = parcelRequire("4onjs");

var $izFg3 = parcelRequire("izFg3");

var $1xw2Y = parcelRequire("1xw2Y");

var $2akJT = parcelRequire("2akJT");

var $aL1Vp = parcelRequire("aL1Vp");
const $b33cd1fc52bb1ad5$export$fedd53519a0e2bce = ()=>{
    const { data: favourites } = (0, $fvmYM.useUserGetFavouritesQuery)();
    const { data: statusStats } = (0, $fvmYM.useStatisticsGetChargePointStatusStatsForAllQuery)();
    const text = (0, $aL1Vp.default)();
    const msgs = (0, $6uMv9.useRef)(null);
    (0, $8Mqhq.useMountEffect)(()=>{
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
                {
                    sticky: true,
                    severity: "info",
                    detail: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                        code: "lblLMIIssueNotification",
                        values: {
                            link: {
                                href: text("linkSupportHalo"),
                                target: "_new"
                            },
                            link2: {
                                href: text("linkSupportAura"),
                                target: "_new"
                            }
                        },
                        "data-testid": "informationBanner-msg"
                    }),
                    closable: false
                }
            ]);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-12 md:col-10 flex-order-1 md:flex-order-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lU1sx.Messages), {
        ref: msgs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cfan9.Card), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2akJT.LazyTabView), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $96Lrx.TabPanel), {
        leftIcon: "pi pi-bell mr-2",
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblAlarms"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iKfQu.DashboardAlarmsWidget), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $96Lrx.TabPanel), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblLatestErrorsWidget"
        }),
        leftIcon: "pi pi-info-circle mr-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $04f8dfdba5fdac3d$export$9fa80d37c94d77bd), null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-12 md:col-2 flex-order-0 md:flex-order-1 stats-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4onjs.ChargePointStatusDashboardWidget), {
        chargePointStatusStats: statusStats
    }), favourites?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $izFg3.ChargePointFavoritesDashboardWidget), {
        favourites: favourites
    }) : null)));
};
var $b33cd1fc52bb1ad5$export$2e2bcd8739ae039 = $b33cd1fc52bb1ad5$export$fedd53519a0e2bce;





var $6uMv9 = parcelRequire("6uMv9");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $52Dbq = parcelRequire("52Dbq");

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $7Ilk7 = parcelRequire("7Ilk7");

var $hJq0b = parcelRequire("hJq0b");

var $3YfCm = parcelRequire("3YfCm");

var $aL1Vp = parcelRequire("aL1Vp");

var $fvmYM = parcelRequire("fvmYM");

var $iktXR = parcelRequire("iktXR");

var $f7UZA = parcelRequire("f7UZA");

var $2460e = parcelRequire("2460e");

var $aN41L = parcelRequire("aN41L");
const $de056d539b200fbe$export$4d01d05dd3834e6f = ({ organisationId: organisationId })=>{
    const text = (0, $aL1Vp.default)();
    const { data: organisation } = (0, $fvmYM.useCompanyGetCompanyByIdQuery)({
        companyId: organisationId
    }, {
        skip: !organisationId
    });
    const [updateOrganisation, { isLoading: isLoading }] = (0, $fvmYM.useCompanyUpdateCompanyMutation)();
    const schema = $7Ilk7.object().shape({
        name: $7Ilk7.string().required(text("msgCompanyNameRequired")),
        email: $7Ilk7.string().email(text("msgEmailFormatIsIncorrect"))
    });
    const { handleSubmit: handleSubmit, register: register, formState: { errors: errors, isSubmitting: isSubmitting, isDirty: isDirty, isValid: isValid } } = (0, $cbVaW.useForm)({
        resolver: (0, $hJq0b.yupResolver)(schema),
        mode: "all",
        values: {
            name: organisation?.name,
            description: organisation?.description,
            email: organisation?.email,
            phone: organisation?.phone
        }
    });
    const onSubmit = (data)=>{
        updateOrganisation({
            company: {
                ...organisation,
                ...data
            }
        }).unwrap().then(()=>(0, $2460e.notifySuccess)(text("msgUpdateOrganisation"))).catch(()=>{
            (0, $2460e.notifyError)(text("msgUpdateOrganisationError"));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: "flex w-full",
        title: text("lblCompanyModal", {
            name: organisation?.name
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            label: text("btnSave"),
            primary: true,
            type: "submit",
            form: "organisation-details-form",
            disabled: isSubmitting || !isDirty || !isValid || isLoading
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        id: "organisation-details-form",
        "data-testid": "organisation-details-form",
        onSubmit: handleSubmit(onSubmit),
        noValidate: true,
        autoComplete: "off"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "company-name-input",
        wrapperClassName: "mt-6",
        id: "name",
        labelText: text("lblName"),
        ...register("name"),
        error: errors.name?.message,
        maxLength: (0, $aN41L.MAX_NAME_LENGTH)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "company-description-input",
        wrapperClassName: "mt-6",
        id: "description",
        labelText: text("lblDescription"),
        ...register("description"),
        error: errors.description?.message,
        maxLength: (0, $aN41L.MAX_ORG_DESC_LENGTH)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "company-email-input",
        wrapperClassName: "mt-6",
        id: "email",
        labelText: text("lblEmail"),
        ...register("email"),
        error: errors.email?.message,
        maxLength: (0, $aN41L.MAX_ORG_EMAIL_LENGTH)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "company-phone-input",
        wrapperClassName: "mt-6",
        id: "phone",
        labelText: text("lblPhone"),
        ...register("phone"),
        error: errors.phone?.message,
        maxLength: (0, $aN41L.MAX_ORG_PHONE_NO_LENGTH)
    })));
};





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $2naDF = parcelRequire("2naDF");

var $35vY7 = parcelRequire("35vY7");

var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");
const $153420c866dd89f4$export$8f348eda099645d8 = /*#__PURE__*/ (0, $6uMv9.memo)(function CompanyUsersWidget({ className: className, style: style, openUserModal: openUserModal, users: users, removeUser: removeUser }) {
    const text = (0, $aL1Vp.default)();
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [pageSize] = (0, $6uMv9.useState)(20);
    const offset = currentPage * pageSize;
    const handlePageClick = (selected)=>{
        setCurrentPage(selected);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "table-users",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblUsersWidget"
        }),
        headerButtons: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                "data-testid": "table-users-add-btn",
                onClick: ()=>openUserModal(),
                type: "button",
                size: "sm"
            }, text("btnAdd"))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-username-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-useredit-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblRole"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-userremove-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblRemove"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, users?.slice(offset, offset + pageSize).map((user)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: user?.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-username-body"
        }, user.firstName, "", " ", user.lastName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-userrole-body"
        }, user.roleInCompany), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-userremoveBtn-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            type: "button",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "Remove",
            onClick: ()=>removeUser(user),
            className: "btn btn-danger btn-xs btn-icon",
            "data-testid": "table-userbtn-remove"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "fa fa-remove"
        }))))))), users?.length > 20 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        setPageIndex: handlePageClick,
        totalCount: users.length,
        pageSize: pageSize,
        pageIndex: currentPage,
        displayedChargers: pageSize
    }), !users && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-xsmall",
        "data-testid": "user-loading"
    }));
});





var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $aL1Vp = parcelRequire("aL1Vp");

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $lWDz3 = parcelRequire("lWDz3");

var $8gLAc = parcelRequire("8gLAc");

var $2naDF = parcelRequire("2naDF");

var $iktXR = parcelRequire("iktXR");

var $f7UZA = parcelRequire("f7UZA");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $4AFFH = parcelRequire("4AFFH");

var $aL1Vp = parcelRequire("aL1Vp");
const $04dcc6467a15eabc$export$a5138afffb78d1a1 = ({ onClose: onClose, companyId: companyId })=>{
    const text = (0, $aL1Vp.default)();
    const [email, setEmail] = (0, $6uMv9.useState)("");
    const { data: users, isFetching: isFetching } = (0, $fvmYM.useUserGetFilteredQuery)({
        email: email,
        noOfItems: 50
    }, {
        skip: !email
    });
    const [addUserToOrganisation] = (0, $fvmYM.useCompanyAddRoleToUserMutation)();
    const { handleSubmit: handleSubmit, register: register } = (0, $cbVaW.useForm)({
        mode: "all"
    });
    const onSubmit = (data)=>{
        setEmail(data.email);
    };
    const handleAddUser = (id)=>{
        if (id) addUserToOrganisation({
            companyId: companyId,
            userId: id,
            role: {
                companyId: companyId,
                chargePointUserId: id,
                claim: "Admin"
            }
        }).unwrap().then(()=>{
            (0, $2460e.notifySuccess)(text("msgUserAddedToOrg"));
            onClose();
        }).catch(()=>(0, $2460e.notifyError)(text("msgUserNotAdded")));
        else (0, $2460e.notifyError)(text("msgUserNotAdded"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        size: "lg",
        title: text("lblAddUser"),
        titleButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            size: "sm",
            onClick: onClose,
            primary: false,
            className: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4AFFH.CloseIcon), {
                size: 18
            }),
            "data-testid": "info-block-close-btn"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "inline-flex w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        id: "search-form",
        className: "w-full",
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "email-input",
        id: "email-input",
        ...register("email"),
        labelText: text("lblEmail")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        type: "submit",
        form: "search-form",
        "data-testid": "search-btn",
        primary: true,
        className: "ml-4",
        loading: isFetching,
        label: text("btnSearch")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblName")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblEmail")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblAdd")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, users && users.length > 0 ? users?.map((user)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: user.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, user.fullName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, user.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            "data-testid": "add-user-btn",
            onClick: ()=>handleAddUser(user?.id),
            className: "btn btn-ok btn-xs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
            icon: (0, $iJ6Cm.faPlus)
        }))))) : null)));
};





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $2naDF = parcelRequire("2naDF");

var $aL1Vp = parcelRequire("aL1Vp");
const $e1e20b990f826b98$export$e08e80fd9e5400f9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function SupportPropertiesWidget({ className: className, style: style, company: company }) {
    const text = (0, $aL1Vp.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblPropertiesWidget"),
        "data-testid": "partner-properties-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "partner-name-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPartnerField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "partner-name-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
        className: "btn btn-link btn-xs",
        "data-testid": "table-partner-name",
        to: `/partner/${company?.partnerId}`
    }, company?.partnerName))))));
});





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $k0EDO = parcelRequire("k0EDO");

var $2naDF = parcelRequire("2naDF");

var $35vY7 = parcelRequire("35vY7");

var $duQ8A = parcelRequire("duQ8A");

var $aL1Vp = parcelRequire("aL1Vp");

var $ans3G = parcelRequire("ans3G");

var $1dgSH = parcelRequire("1dgSH");
const $cb240273abbef35f$export$2ac1bf50a1a03774 = /*#__PURE__*/ (0, $6uMv9.memo)(function CompanyRfidWidget({ className: className, style: style, nfcTags: nfcTags, openNfcTag: openNfcTag, removeTag: removeTag, companyId: companyId }) {
    const text = (0, $aL1Vp.default)();
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [pageSize] = (0, $6uMv9.useState)(20);
    const offset = currentPage * pageSize;
    const handlePageClick = (selected)=>{
        setCurrentPage(selected);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "table-rfid",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblRFID"),
        headerButtons: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
                dataTestId: "table-rfid-add-btn",
                type: "button",
                onClick: ()=>openNfcTag({
                        companyId: companyId
                    }),
                code: "btnAdd",
                small: true
            })
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-idrfid-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-comment-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblComment"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-editrfid-heading"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, nfcTags?.slice(offset, offset + pageSize).map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: tag?.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-idrfid-body"
        }, tag?.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-comment-body"
        }, tag?.comment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.default), {
            className: "ml-auto",
            "data-testid": "menu-toggle-rfid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: ()=>openNfcTag(tag),
            text: text("btnEdit"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ans3G.EditIcon), {
                size: 14
            }),
            key: "btnEditRfid",
            "data-testid": "table-rfid-body-edit"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: ()=>removeTag(tag),
            text: text("btnRemove"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1dgSH.default), {
                size: 14
            }),
            key: "btnRemoveRfid",
            "data-testid": "table-rfid-body-remove"
        }))))))), nfcTags && nfcTags?.length > 20 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        setPageIndex: handlePageClick,
        totalCount: nfcTags?.length,
        pageSize: pageSize,
        pageIndex: currentPage,
        displayedChargers: pageSize
    }), !nfcTags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-xsmall",
        "data-testid": "rfid-loading"
    }));
});





var $i4kGB = parcelRequire("i4kGB");

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $3YfCm = parcelRequire("3YfCm");

var $aL1Vp = parcelRequire("aL1Vp");

var $8ugaX = parcelRequire("8ugaX");

var $f7UZA = parcelRequire("f7UZA");

var $fvmYM = parcelRequire("fvmYM");

var $2naDF = parcelRequire("2naDF");

var $8N7S6 = parcelRequire("8N7S6");

var $2460e = parcelRequire("2460e");

var $cq3ae = parcelRequire("cq3ae");
const $85ee32a9116d53bb$export$a95740f710eb0059 = /*#__PURE__*/ (0, $6uMv9.memo)(({ companyId: companyId })=>{
    const text = (0, $aL1Vp.default)();
    const [confirmationModalIsOpened, setConfirmationModalIsOpened] = (0, $6uMv9.useState)(false);
    const [dateRange, setDateRange] = (0, $6uMv9.useState)({
        startTime: "",
        endTime: ""
    });
    const { currentData: chargingSessions = [], isFetching: isFetching } = (0, $fvmYM.useCompanyGetChargingSessionsByRangeQuery)({
        companyId: companyId,
        ...dateRange
    }, {
        skip: !dateRange.startTime && !dateRange.endTime
    });
    const [deleteChargingSessions] = (0, $fvmYM.useCompanyDeleteChargingSessionsMutation)();
    const { register: register, handleSubmit: handleSubmit, formState: { isDirty: isDirty } } = (0, $cbVaW.useForm)({
        mode: "all"
    });
    const handleChargingSession = (data)=>{
        setDateRange(data);
    };
    const handleRemoveChargingSessions = ()=>{
        setConfirmationModalIsOpened(false);
        deleteChargingSessions({
            ...dateRange,
            companyId: companyId
        }).unwrap().then(()=>(0, $2460e.notifySuccess)(text("msgDeleteSessionsSuccess"))).catch(()=>(0, $2460e.notifyError)(text("msgCouldNotDeleteSessions")));
    };
    const renderChargingSessions = ()=>{
        if (chargingSessions && chargingSessions.length === 0) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblStart")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblEnd")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblCharger")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblConsumption")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, chargingSessions?.map((session)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
                key: session.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
                dataTestId: `session-start-${session.id}`
            }, (0, $8N7S6.dateLocalize)(session.startTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
                dataTestId: `session-end-${session.id}`
            }, (0, $8N7S6.dateLocalize)(session.endTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
                dataTestId: `session-chargepoint-id-${session.id}`
            }, session.chargePointId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
                dataTestId: `session-total-consuption-${session.id}`
            }, `${session.totalConsumptionKwh ?? "---"} ${text("lblKWh")}`)))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblChargingSessionsWidget")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: handleSubmit(handleChargingSession)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8ugaX.default), {
        wrapperClassName: "mt-5",
        ...register("startTime"),
        "data-testid": "from-input",
        id: "from-date",
        labelText: text("lblFromDate")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8ugaX.default), {
        wrapperClassName: "mt-5",
        ...register("endTime"),
        "data-testid": "to-input",
        id: "to-date",
        labelText: text("lblToDate")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "mt-5 flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        loading: isFetching,
        size: "sm",
        type: "submit",
        label: text("btnGet"),
        disabled: !isDirty,
        "data-testid": "button-get"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        className: "ml-3",
        size: "sm",
        label: text("btnClear"),
        disabled: chargingSessions.length === 0,
        onClick: ()=>setConfirmationModalIsOpened(true),
        "data-testid": "button-clear"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "mt-5 overflow-y-auto max-h-30rem"
    }, renderChargingSessions())), confirmationModalIsOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cq3ae.default), {
        title: text("lblChargingSessionsWidget"),
        message: text("lblConfirmDeletingChargingSession"),
        onConfirm: ()=>handleRemoveChargingSessions(),
        onClose: ()=>setConfirmationModalIsOpened(false)
    }));
});





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");

var $k0EDO = parcelRequire("k0EDO");

var $1xw2Y = parcelRequire("1xw2Y");

var $3YfCm = parcelRequire("3YfCm");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $k0EDO = parcelRequire("k0EDO");

var $ka0YZ = parcelRequire("ka0YZ");

var $1xw2Y = parcelRequire("1xw2Y");

var $3YfCm = parcelRequire("3YfCm");

var $bhqzv = parcelRequire("bhqzv");
function $40dae8668e8b5a0c$export$3791ced61b6d950a(partnerId, userId) {
    return (0, $bhqzv.default).del({
        path: "/partners/" + partnerId + "/users/" + userId
    });
}





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $lWDz3 = parcelRequire("lWDz3");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $akcQ4 = parcelRequire("akcQ4");

var $ka0YZ = parcelRequire("ka0YZ");

var $bhqzv = parcelRequire("bhqzv");
function $6e8a5482875c5600$export$2c3a8e05396a78be(query) {
    return (0, $bhqzv.default)({
        path: "/users/",
        query: query
    });
}





var $1xw2Y = parcelRequire("1xw2Y");

var $k0EDO = parcelRequire("k0EDO");

var $bhqzv = parcelRequire("bhqzv");
function $13078611131101c4$export$65c6abc59763dd03(partnerId, userId) {
    return (0, $bhqzv.default).put({
        path: `/partners/${partnerId}/users/${userId}`
    });
}





var $cGtAV = parcelRequire("cGtAV");

var $2naDF = parcelRequire("2naDF");

var $aL1Vp = parcelRequire("aL1Vp");
const $e29cc5a124a9b343$export$e32ce4c15917b0f7 = (0, $akcQ4.default).div`
    display: flex;
    gap: 10px;
    margin-bottom: 5px;
`;
const $e29cc5a124a9b343$export$bee58ad7d6864404 = (0, $akcQ4.default)((0, $cGtAV.SInput))`
    flex: 1;
`;
const $e29cc5a124a9b343$export$9dbe66975d726c66 = (0, $akcQ4.default)((0, $k0EDO.Button))`
    padding: 3px;
    border-radius: 3px;
`;
const $e29cc5a124a9b343$export$c6bb578eab8ee061 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function AddPartnerAdminModal({ adminPartners: adminPartners, onLoadPartnerAdmin: onLoadPartnerAdmin, partnerId: partnerId, close: close, className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [email, setEmail] = (0, $6uMv9.useState)("");
    const adminPartnersIds = adminPartners.map((partner)=>partner.id);
    const { execute: findUsers, value: users, status: findingUsersStatus } = (0, $ka0YZ.default)(()=>(0, $6e8a5482875c5600$export$2c3a8e05396a78be)({
            noOfItems: 50,
            email: email
        }).then((users)=>users.filter((user)=>!adminPartnersIds.includes(user.id))), [
        email,
        adminPartners
    ]);
    const { execute: addPartner } = (0, $ka0YZ.default)((userId)=>(0, $13078611131101c4$export$65c6abc59763dd03)(partnerId, userId).then(()=>{
            onLoadPartnerAdmin();
            close();
        }), [
        partnerId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-header",
        "data-testid": "nedPartnerHeader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPartnerAdminModal"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e29cc5a124a9b343$export$e32ce4c15917b0f7, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e29cc5a124a9b343$export$bee58ad7d6864404, {
        placeholder: text("lblEmailField"),
        value: email,
        onChange: (event)=>setEmail(event.target.value)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
        loading: findingUsersStatus === (0, $ka0YZ.Status).PENDING,
        onClick: findUsers,
        title: text("btnSearch"),
        "data-testid": "searchBtn",
        small: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
        small: true,
        onClick: close,
        title: text("btnCancel"),
        "data-testid": "cancelBtn"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "theadNameModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "theadEmailModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmail"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "theadAddModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAdd"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, users?.map((user, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: Math.random()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "userName-" + i
        }, user.firstName, " ", user.lastName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "userEmail-" + i
        }, user.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e29cc5a124a9b343$export$9dbe66975d726c66, {
            tooltip: text("btnAdd"),
            onClick: ()=>addPartner(user.id),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
                icon: (0, $iJ6Cm.faPlus)
            }),
            "data-testid": "userAdd-" + i
        }))))))));
});





var $2naDF = parcelRequire("2naDF");

var $aL1Vp = parcelRequire("aL1Vp");

var $8gLAc = parcelRequire("8gLAc");
const $603c8bfd048b6acc$export$95afdcbad550b7c3 = (0, $akcQ4.default)((0, $k0EDO.Button))`
    &,
    &:not(:hover) {
        background-color: ${({ theme: theme })=>theme.brandColors.CA_Coral};
        color: ${({ theme: theme })=>theme.font.lightestColor};
        padding: 3px;
        border-radius: 3px;
    }

    &:hover {
        background-color: ${({ theme: theme })=>theme.font.errorColor};
        color: ${({ theme: theme })=>theme.font.lightestColor};
    }

    &:disabled,
    &:disabled:hover {
        background-color: ${({ theme: theme })=>theme.checkbox.disabledMarkColor};
    }
`;
const $603c8bfd048b6acc$export$1a45aa3975793088 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function PartnerAdminsWidget({ partnerId: partnerId, partnerUsers: partnerUsers, reload: reload, className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [isPartnerAdminModalOpened, setIsPartnerAdminModalOpened] = (0, $6uMv9.useState)(false);
    const { execute: remove } = (0, $ka0YZ.default)((userId)=>(0, $40dae8668e8b5a0c$export$3791ced61b6d950a)(partnerId, userId).then(reload), [
        partnerId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
            title: text("btnAdd"),
            onClick: ()=>setIsPartnerAdminModalOpened(true),
            small: true,
            dataTestId: "addPartnerAdmin"
        }),
        title: text("lblPartnerAdmins"),
        "data-testid": "partnerAdmins"
    }, isPartnerAdminModalOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $e29cc5a124a9b343$export$c6bb578eab8ee061), {
        adminPartners: partnerUsers || [],
        partnerId: partnerId,
        close: ()=>setIsPartnerAdminModalOpened(false),
        onLoadPartnerAdmin: reload
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "theadName"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "theadEmail"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmail"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "theadRemove"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblRemove"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, partnerUsers?.map((user, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: Math.random()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "userName-" + i
        }, user.firstName, " ", user.lastName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "userEmail-" + i
        }, user.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($603c8bfd048b6acc$export$95afdcbad550b7c3, {
            tooltip: text("btnRemove"),
            onClick: ()=>remove(user.id),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
                className: "fa fa-remove"
            }),
            "data-testid": "userRemove-" + i,
            small: true
        })))))));
});





var $6uMv9 = parcelRequire("6uMv9");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $lWDz3 = parcelRequire("lWDz3");

var $8gLAc = parcelRequire("8gLAc");


var $1xw2Y = parcelRequire("1xw2Y");

var $2naDF = parcelRequire("2naDF");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $iktXR = parcelRequire("iktXR");

var $4AFFH = parcelRequire("4AFFH");

var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");
const $d3bb1b0970a85d6f$export$bc360463998fa093 = /*#__PURE__*/ (0, $6uMv9.memo)(function AddCompanyChargerModal({ companyId: companyId, close: close, cancel: cancel }) {
    const text = (0, $aL1Vp.default)();
    const [serialNumber, setSerialNumber] = (0, $6uMv9.useState)("");
    const [search, setSearch] = (0, $6uMv9.useState)(false);
    const { currentData: chargePointsData, isFetching: chargePointLoading } = (0, $fvmYM.useChargePointGetChargePointsQuery)({
        id: serialNumber,
        noOfItems: 20
    }, {
        skip: !search,
        refetchOnMountOrArgChange: true
    });
    const [addCharger] = (0, $fvmYM.useCompanyAddChargePointToCompanyMutation)();
    const addChargerToCompany = async (companyId, chargePointCredentials)=>{
        try {
            await addCharger({
                companyId: companyId,
                chargePointCredentials: chargePointCredentials
            }).unwrap().then(()=>(0, $2460e.notifySuccess)(text("lblChargerWasAddedToOrg")));
            close();
        } catch (error) {
            (0, $2460e.notifyError)(text("msgChargerNotAddedtoOrganisation"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: text("lblChargerAddingModal"),
        size: "lg",
        titleButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            size: "sm",
            onClick: cancel,
            primary: false,
            className: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4AFFH.CloseIcon), {
                size: 18
            }),
            "data-testid": "info-block-close-btn"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $e29cc5a124a9b343$export$e32ce4c15917b0f7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "input-search",
        labelText: text("lblSerialNumberShortField"),
        value: serialNumber,
        onChange: (event)=>setSerialNumber(event.target.value),
        "data-testid": "input-search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        loading: chargePointLoading,
        onClick: ()=>setSearch(true),
        "data-testid": "btn-search",
        label: text("btnSearch"),
        size: "sm"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-serial"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSerialNumber"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-owner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblOwner"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-company"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblOrganisation"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-add"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAdd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, chargePointsData && chargePointsData?.items?.map((chargePoint, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-th-serial-" + chargePoint.id
        }, chargePoint.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-th-name-" + chargePoint.id
        }, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-th-ownerId-" + chargePoint.id
        }, chargePoint?.ownerName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-th-company-" + chargePoint.id
        }, chargePoint?.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-th-add-" + chargePoint.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $e29cc5a124a9b343$export$9dbe66975d726c66), {
            tooltip: chargePoint.companyId ? text("msgChargerIsInUse") : text("btnAdd"),
            onClick: ()=>addChargerToCompany(companyId, {
                    id: chargePoint?.id,
                    wifiPassword: chargePoint?.wifiPassword
                }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
                icon: (0, $iJ6Cm.faPlus)
            }),
            dataTestId: `AddButton-${chargePoint?.id}`,
            disabled: chargePoint.companyId
        })))))));
});





var $35vY7 = parcelRequire("35vY7");

var $2naDF = parcelRequire("2naDF");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $aL1Vp = parcelRequire("aL1Vp");
const $7ad4ffecdf2f3c20$export$7bcc148fbf4d7722 = /*#__PURE__*/ (0, $6uMv9.memo)(function CompanyChargersWidget({ chargePoints: chargePoints, loadingStatus: loadingStatus, companyId: companyId, className: className, style: style, paginationData: paginationData, setPageIndex: setPageIndex }) {
    const text = (0, $aL1Vp.default)();
    const [removeChargePointFromCompany, { isLoading: isLoading }] = (0, $fvmYM.useCompanyRemoveChargePointMutation)();
    const [isAddCompanyChargerModalOpened, setIsAddCompanyChargerModalOpened] = (0, $6uMv9.useState)(false);
    const handleRemoveChargePoint = (chargePointId)=>{
        if (!companyId) {
            (0, $2460e.notifyError)(text("msgCouldNotRemoveCharger"));
            return;
        }
        removeChargePointFromCompany({
            companyId: companyId,
            chargePointId: chargePointId
        }).unwrap().then(()=>(0, $2460e.notifySuccess)(text("msgChargerRemovedFromOrg", {
                chargePointId: chargePointId
            }))).catch(()=>(0, $2460e.notifyError)(text("msgCouldNotRemoveCharger")));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        headerButtons: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
                small: true,
                title: text("btnAdd"),
                onClick: ()=>{
                    setIsAddCompanyChargerModalOpened(true);
                },
                "data-testid": "btn-add-charger"
            })
        ],
        title: text("lblChargersWidget"),
        "data-testid": "company-chargers-table"
    }, isAddCompanyChargerModalOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d3bb1b0970a85d6f$export$bc360463998fa093), {
        close: ()=>{
            setIsAddCompanyChargerModalOpened(false);
        },
        cancel: ()=>setIsAddCompanyChargerModalOpened(false),
        companyId: companyId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-serial"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSerialNumber"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, chargePoints?.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: Math.random()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-td-serial-" + chargePoint.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            to: `/chargepoints/${chargePoint?.id}`,
            className: "btn btn-link btn-xs",
            "data-testid": "table-chargePoint-name"
        }, chargePoint.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-td-name-" + chargePoint.id
        }, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-td-remove-" + chargePoint.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $603c8bfd048b6acc$export$95afdcbad550b7c3), {
            dataTestId: `danger-button-${chargePoint.id}`,
            tooltip: !!chargePoint.loadBalancerGroupId || isLoading ? text("msgRemoveChargerTooltip") : text("lblRemove"),
            onClick: ()=>handleRemoveChargePoint(chargePoint.id),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
                className: "fa fa-remove"
            }),
            disabled: !!chargePoint.loadBalancerGroupId || isLoading,
            small: true
        })))))), chargePoints?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        "data-testid": "pagination-chargers",
        totalCount: paginationData?.totalCount,
        pageIndex: paginationData?.pageIndex,
        pageSize: paginationData?.pageSize,
        displayedChargers: chargePoints?.length,
        setPageIndex: (index)=>setPageIndex(index),
        showButtons: false
    }), (loadingStatus || isLoading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-small",
        "data-testid": "chargers-loading"
    }));
});





var $9ekKl = parcelRequire("9ekKl");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $k0EDO = parcelRequire("k0EDO");

var $2naDF = parcelRequire("2naDF");

var $35vY7 = parcelRequire("35vY7");

var $aL1Vp = parcelRequire("aL1Vp");
const $64c0ec9a5159fe83$export$98739da767720988 = /*#__PURE__*/ (0, $6uMv9.memo)(function CompanyMeasurementdevicesWidget({ className: className, style: style, openMeasurementModal: openMeasurementModal, measurementDevices: measurementDevices, removeMeasurementDevice: removeMeasurementDevice }) {
    const text = (0, $aL1Vp.default)();
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [pageSize] = (0, $6uMv9.useState)(20);
    const offset = currentPage * pageSize;
    const handlePageClick = (selected)=>{
        setCurrentPage(selected);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "table-md",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblMeasurementDevices"),
        headerButtons: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
                dataTestId: "table-md-add-btn",
                type: "button",
                code: "btnAdd",
                small: true,
                onClick: ()=>openMeasurementModal(null)
            })
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-mdnumber-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSerialNumber"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-mdname-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, measurementDevices?.slice(offset, offset + pageSize).map((device)=>{
        const mdBelongsToLBGroup = !!device?.loadBalancerGroupId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: device?.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-md-id-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            to: `/measurementDevice/${device?.id}`,
            className: "btn btn-link btn-xs",
            "data-testid": "table-md-chargePoint-name"
        }, device.serialNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-md-name-body"
        }, device.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-md-removeBtn-body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            disabled: mdBelongsToLBGroup,
            type: "button",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: mdBelongsToLBGroup ? text("msgMeasurementDeviceIsPartOfLBGroup") : undefined,
            onClick: ()=>removeMeasurementDevice(device),
            className: "btn btn-danger btn-xs btn-icon",
            "data-testid": "table-md-remove"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "fa fa-remove"
        }))));
    }))), measurementDevices?.length > 20 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        setPageIndex: handlePageClick,
        totalCount: measurementDevices?.length,
        pageSize: pageSize,
        pageIndex: currentPage,
        displayedChargers: pageSize
    }), !measurementDevices && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-xsmall",
        "data-testid": "md-loading"
    }));
});





var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $lWDz3 = parcelRequire("lWDz3");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $8gLAc = parcelRequire("8gLAc");

var $f7UZA = parcelRequire("f7UZA");

var $4AFFH = parcelRequire("4AFFH");

var $iktXR = parcelRequire("iktXR");

var $2naDF = parcelRequire("2naDF");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $aL1Vp = parcelRequire("aL1Vp");
const $4d583941a9ccef11$export$16e6362e93c84a4 = /*#__PURE__*/ (0, $6uMv9.memo)(({ onClose: onClose, companyId: companyId })=>{
    const text = (0, $aL1Vp.default)();
    const [serialNumber, setSerialNumber] = (0, $6uMv9.useState)("");
    const { currentData: measurementDevices = [], isLoading: measurementDevicesIsLoading } = (0, $fvmYM.useMeasurementDevicesGetFilteredQuery)({
        serialNumber: serialNumber,
        limit: 20
    }, {
        skip: !serialNumber
    });
    const [addMDToOrganisation] = (0, $fvmYM.useCompanyAddMeasurementDeviceToCompanyMutation)();
    const { handleSubmit: handleSubmit, register: register } = (0, $cbVaW.useForm)({
        mode: "all"
    });
    const onSubmit = (data)=>{
        setSerialNumber(data.serialNumber);
    };
    const handleMDAdd = (device)=>{
        if (device) addMDToOrganisation({
            companyId: companyId,
            measurementDeviceCredentials: {
                serialNumber: device.serialNumber
            }
        }).unwrap().then(()=>{
            onClose();
            (0, $2460e.notifySuccess)(text("msgMeasurementDeviceWasAdded"));
        }).catch(()=>(0, $2460e.notifyError)(text("msgMeasurementDeviceCouldNotBeAdded")));
        else (0, $2460e.notifyError)(text("msgMeasurementDeviceCouldNotBeAdded"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        size: "lg",
        title: text("lblAddMeasurementDeviceModal"),
        titleButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            size: "sm",
            onClick: onClose,
            primary: false,
            className: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4AFFH.CloseIcon), {
                size: 18
            }),
            "data-testid": "info-block-close-btn"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "inline-flex w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        "data-testid": "search-form",
        id: "search-form",
        className: "w-full",
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "serial-number-input",
        id: "serial-number-input",
        ...register("serialNumber"),
        labelText: text("lblSerialNumberShortField")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        type: "submit",
        form: "search-form",
        primary: true,
        className: "ml-4",
        loading: measurementDevicesIsLoading,
        "data-testid": "search-btn",
        label: text("btnSearch")
    })), measurementDevices && measurementDevices.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "mt-5 overflow-y-auto max-h-30rem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblSerialNumber")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblName")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblOrganisation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, text("lblAdd")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, measurementDevices?.map((device)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: device.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, device.serialNumber), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, device.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, device.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            "data-testid": "add-md-btn",
            onClick: ()=>handleMDAdd(device),
            className: "btn btn-ok btn-xs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
            icon: (0, $iJ6Cm.faPlus)
        })))))))));
});



var $f7UZA = parcelRequire("f7UZA");

var $cq3ae = parcelRequire("cq3ae");
const $1fc61c8580c18e30$export$2954431ebbef887d = ()=>{
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const { companyId: companyId } = (0, $84v65.useParams)();
    const [addUserModalIsOpened, setAddUserModalIsOpened] = (0, $6uMv9.useState)(false);
    const [addNewRfidTagModalIsOpened, setAddNewRfidTagModalIsOpened] = (0, $6uMv9.useState)(false);
    const [addNewMeasurementDeviceModalIsOpened, setAddNewMeasurementDeviceModalIsOpened] = (0, $6uMv9.useState)(false);
    const [deleteOrganisationModalIsOpened, setDeleteOrganisationModalIsOpened] = (0, $6uMv9.useState)(false);
    const [rfidTag, setRfidTag] = (0, $6uMv9.useState)();
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const { data: organisation } = (0, $fvmYM.useCompanyGetCompanyByIdQuery)({
        companyId: companyId
    }, {
        skip: !companyId
    });
    const { data: nfcTags = [] } = (0, $fvmYM.useCompanyGetNfcTagsQuery)({
        companyId: companyId
    }, {
        skip: !companyId
    });
    const { data: users = [] } = (0, $fvmYM.useCompanyGetUsersQuery)({
        companyId: companyId
    }, {
        skip: !companyId
    });
    const { data: measurementDevices = [] } = (0, $fvmYM.useCompanyGetDeviceByCompanyIdQuery)({
        companyId: companyId
    }, {
        skip: !companyId
    });
    const { data: chargePoints } = (0, $fvmYM.useCompanyGetChargePointsPagedQuery)({
        page: currentPage,
        noOfItems: 15,
        companyId: companyId,
        CompanyId: companyId
    }, {
        skip: !companyId
    });
    const [removeUser] = (0, $fvmYM.useCompanyRemoveUserMutation)();
    const [removeTag] = (0, $fvmYM.useNfcTagDeleteMutation)();
    const [removeMeasurementDevice] = (0, $fvmYM.useCompanyRemoveMeasurementDeviceMutation)();
    const [deleteOrganisation] = (0, $fvmYM.useCompanyDeleteCompanyMutation)();
    const { data: loadBalancerGroups, isFetching: loadingGroups } = (0, $fvmYM.useCompanyGetLoadbalancerGroupsPagedQuery)({
        companyId: companyId
    }, {
        skip: !companyId
    });
    const handleRemoveTag = (rfidTag)=>{
        if (!confirm(text("lblConfirmDeletingRFIDTag"))) return;
        if (rfidTag && rfidTag.id) removeTag({
            nfcTagId: rfidTag.id
        }).unwrap().then(()=>(0, $2460e.notifySuccess)(text("msgRFIDRemoved"))).catch(()=>(0, $2460e.notifyError)(text("msgRFIDNotRemoved")));
        else (0, $2460e.notifyError)(text("msgRFIDNotRemoved"));
    };
    const handleRemoveUser = (user)=>{
        if (user && user.id) removeUser({
            companyId: companyId,
            userId: user.id
        }).unwrap().then(()=>(0, $2460e.notifySuccess)(text("msgUserRemoveFromOrg"))).catch((error)=>{
            const errormessage = error?.data.messageCode;
            if (errormessage === "msgUserWithMDCantBeRemovedFromCompany" || errormessage === "msgUserWithTagsCantBeRemovedFromCompany") (0, $2460e.notifyError)(text(errormessage));
            else (0, $2460e.notifyError)(text("msgUserNotRemovedFromOrg"));
        });
        else (0, $2460e.notifyError)(text("msgUserRemoveFromOrgError"));
    };
    const handleRemoveMeasurementDevice = (device)=>{
        if (device && device.id) removeMeasurementDevice({
            companyId: companyId,
            measurementDeviceId: device.id
        }).unwrap().then(()=>(0, $2460e.notifySuccess)(text("msgDeviceRemoved"))).catch(()=>(0, $2460e.notifyError)(text("msgMeasurementDeviceNotRemoved")));
        else (0, $2460e.notifyError)(text("msgMeasurementDeviceNotRemoved"));
    };
    const handleDeleteOrganisation = ()=>{
        if (companyId) deleteOrganisation({
            companyId: companyId
        }).unwrap().then(()=>{
            navigate("/companies");
            (0, $2460e.notifySuccess)(text("msgDeletedOrganisation"));
        }).catch(()=>{
            (0, $2460e.notifyError)(text("msgDeleteCompanyErrorAlert"));
            setDeleteOrganisationModalIsOpened(false);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        id: "delete-organisation",
        label: text("btnDeleteOrganisation"),
        onClick: ()=>setDeleteOrganisationModalIsOpened(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $de056d539b200fbe$export$4d01d05dd3834e6f), {
        organisationId: companyId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $153420c866dd89f4$export$8f348eda099645d8), {
        openUserModal: ()=>setAddUserModalIsOpened(true),
        users: users,
        removeUser: handleRemoveUser
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cb240273abbef35f$export$2ac1bf50a1a03774), {
        companyId: companyId,
        nfcTags: nfcTags,
        openNfcTag: (tag)=>{
            setAddNewRfidTagModalIsOpened(true);
            setRfidTag(tag);
        },
        removeTag: handleRemoveTag
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $64c0ec9a5159fe83$export$98739da767720988), {
        measurementDevices: measurementDevices,
        removeMeasurementDevice: handleRemoveMeasurementDevice,
        openMeasurementModal: ()=>setAddNewMeasurementDeviceModalIsOpened(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $e1e20b990f826b98$export$e08e80fd9e5400f9), {
        company: organisation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $85ee32a9116d53bb$export$a95740f710eb0059), {
        companyId: companyId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7ad4ffecdf2f3c20$export$7bcc148fbf4d7722), {
        companyId: companyId,
        chargePoints: chargePoints?.items ?? [],
        loadingStatus: false,
        paginationData: {
            totalCount: chargePoints?.totalCount ?? 0,
            pageIndex: currentPage,
            pageSize: chargePoints?.pageSize ?? 0
        },
        setPageIndex: setCurrentPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9ekKl.LoadbalancerGroupsWidget), {
        loadBalancerGroups: loadBalancerGroups,
        loadingGroups: loadingGroups
    })))), addNewRfidTagModalIsOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $i4kGB.RfidTagModal), {
        onClose: ()=>{
            setAddNewRfidTagModalIsOpened(false);
            setRfidTag(undefined);
        },
        rfidTag: rfidTag
    }), addUserModalIsOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $04dcc6467a15eabc$export$a5138afffb78d1a1), {
        companyId: companyId,
        onClose: ()=>setAddUserModalIsOpened(false)
    }), addNewMeasurementDeviceModalIsOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4d583941a9ccef11$export$16e6362e93c84a4), {
        onClose: ()=>setAddNewMeasurementDeviceModalIsOpened(false),
        companyId: companyId
    }), deleteOrganisationModalIsOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cq3ae.default), {
        title: text("btnDeleteOrganisation"),
        message: text("msgDeleteCompanyConfirmation"),
        onConfirm: handleDeleteOrganisation,
        onClose: ()=>setDeleteOrganisationModalIsOpened(false)
    }));
};





var $6uMv9 = parcelRequire("6uMv9");

var $52Dbq = parcelRequire("52Dbq");

var $3YfCm = parcelRequire("3YfCm");

var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $cbVaW = parcelRequire("cbVaW");

var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");
const $813e3863f5bfdf1f$var$SButtonWrapper = (0, $akcQ4.default).div`
    display: flex;
    gap: 4px;
    justify-content: flex-end;
`;
const $813e3863f5bfdf1f$export$8df2e2fbd1e54e2a = /*#__PURE__*/ (0, $6uMv9.memo)(function({ onSearch: onSearch, onClear: onClear }) {
    const text = (0, $aL1Vp.default)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { isSubmitting: isSubmitting } } = (0, $cbVaW.useForm)();
    const onSubmit = async ({ name: name, partnerName: partnerName })=>{
        await onSearch({
            name: name,
            partnerName: partnerName
        });
    };
    const handleClear = ()=>{
        reset();
        onClear();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "margin-bottom-small row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        name: "form",
        onSubmit: handleSubmit(onSubmit),
        noValidate: true,
        autoComplete: "off"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        ...register("name"),
        placeholder: "Name",
        className: "form-control",
        "data-testid": "company-name-input"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        ...register("partnerName"),
        placeholder: "Partner",
        className: "form-control",
        "data-testid": "partner-name-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($813e3863f5bfdf1f$var$SButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        loading: isSubmitting,
        type: "submit",
        size: "sm",
        label: text("btnSearch"),
        "data-testid": "search-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("btnClear"),
        onClick: handleClear,
        "data-testid": "clear-btn"
    })))));
});





var $6uMv9 = parcelRequire("6uMv9");

var $lFdao = parcelRequire("lFdao");

var $iZaUM = parcelRequire("iZaUM");

var $2naDF = parcelRequire("2naDF");

var $hBKXa = parcelRequire("hBKXa");

var $8LupL = parcelRequire("8LupL");

var $duQ8A = parcelRequire("duQ8A");

var $hXjVB = parcelRequire("hXjVB");

var $1dgSH = parcelRequire("1dgSH");

var $cq3ae = parcelRequire("cq3ae");

var $aL1Vp = parcelRequire("aL1Vp");
var $8f892dda54dee436$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function OrganisationsTable({ data: data, loading: loading, openCompanyAdmin: openCompanyAdmin, removeOrganisation: removeOrganisation, filter: filter }) {
    const text = (0, $aL1Vp.default)();
    const [deleteOrganisationModalIsOpened, setDeleteOrganisationModalIsOpened] = (0, $6uMv9.useState)(false);
    const [organisationId, setOrganisationId] = (0, $6uMv9.useState)(null);
    const [sorting, setSorting] = (0, $6uMv9.useState)({
        sortType: "name",
        descending: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5",
        "data-testid": "cell-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.SortHeader), {
        code: "lblName",
        id: "name",
        sortType: sorting.sortType,
        descending: sorting.descending,
        onClick: (sortType, descending)=>setSorting({
                sortType: sortType,
                descending: descending
            })
    })), !(0, $8LupL.isSupportDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5",
        "data-testid": "cell-desc"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.SortHeader), {
        code: "lblDescription",
        id: "description",
        sortType: sorting.sortType,
        descending: sorting.descending,
        onClick: (sortType, descending)=>setSorting({
                sortType: sortType,
                descending: descending
            })
    })), (0, $8LupL.isSupportDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5",
        "data-testid": "cell-partner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.SortHeader), {
        code: "lblPartnerField",
        id: "partnerName",
        sortType: sorting.sortType,
        descending: sorting.descending,
        onClick: (sortType, descending)=>setSorting({
                sortType: sortType,
                descending: descending
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5",
        "data-testid": "cell-email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.SortHeader), {
        code: "lblEmail",
        id: "email",
        sortType: sorting.sortType,
        descending: sorting.descending,
        onClick: (sortType, descending)=>setSorting({
                sortType: sortType,
                descending: descending
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5",
        "data-testid": "cell-phone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.SortHeader), {
        code: "lblPhone",
        id: "phone",
        sortType: sorting.sortType,
        descending: sorting.descending,
        onClick: (sortType, descending)=>setSorting({
                sortType: sortType,
                descending: descending
            })
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), {
        isLoading: loading
    }, data?.filter((org)=>{
        if (!filter) return true;
        const lowerCaseFilter = filter.toLowerCase();
        return org.name?.toLowerCase()?.includes(lowerCaseFilter) || org.description?.toLowerCase()?.includes(lowerCaseFilter) || org.email?.toLowerCase()?.includes(lowerCaseFilter);
    }).sort((a, b)=>(0, $hBKXa.sortByString)(a[sorting.sortType] ?? "", b[sorting.sortType] ?? "", sorting.descending)).map((org)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: org.id,
            "data-testid": `row-${org.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `cell-name-${org.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            to: `/company/${org.id}`,
            className: "btn btn-link btn-xs",
            "data-testid": "btn-name"
        }, org.name)), !(0, $8LupL.isSupportDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `cell-desc-${org.id}`
        }, org.description), (0, $8LupL.isSupportDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `cell-partner-${org.id}`
        }, org.partnerName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `cell-email-${org.id}`
        }, org.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, org.phone), !(0, $8LupL.isSupportDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `cell-goto-${org.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.default), {
            "data-testid": `dropdownMenu-${org.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFdao)))(openCompanyAdmin) && openCompanyAdmin(org.id),
            text: text("btnGoToOrganisation"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $hXjVB.GoToIcon), {
                size: 14
            }),
            key: "btnGoToOrg",
            "data-testid": `goTo-${org.id}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: ()=>{
                setDeleteOrganisationModalIsOpened(true);
                setOrganisationId(org?.id);
            },
            text: text("btnDeleteOrganisation"),
            "data-testid": `remove-${org.id}`,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1dgSH.default), {
                size: 14
            })
        }))))))), deleteOrganisationModalIsOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cq3ae.default), {
        title: text("btnDeleteOrganisation"),
        message: text("msgDeleteCompanyConfirmation"),
        onConfirm: ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($lFdao)))(removeOrganisation) && organisationId && removeOrganisation(organisationId);
            setDeleteOrganisationModalIsOpened(false);
        },
        onClose: ()=>{
            setDeleteOrganisationModalIsOpened(false);
            setOrganisationId(null);
        }
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-small",
        "data-testid": "loader"
    }));
});



var $fvmYM = parcelRequire("fvmYM");

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $7Ilk7 = parcelRequire("7Ilk7");

var $hJq0b = parcelRequire("hJq0b");

var $8gLAc = parcelRequire("8gLAc");

var $aL1Vp = parcelRequire("aL1Vp");

var $ccB6k = parcelRequire("ccB6k");

var $iktXR = parcelRequire("iktXR");

var $aodd6 = parcelRequire("aodd6");

var $3jZfA = parcelRequire("3jZfA");
const $cc6a8eaf677b7404$export$8cce66a55d513258 = ({ isOpen: isOpen, onClose: onClose, partners: partners, onSubmit: onSubmit })=>{
    const text = (0, $aL1Vp.default)();
    const toast = (0, $3jZfA.useToast)();
    const schema = $7Ilk7.object().shape({
        name: $7Ilk7.string().required(text("msgNameRequired")),
        description: $7Ilk7.string().required(text("msgDescriptionRequired")),
        email: $7Ilk7.string().email(text("msgEmailInvalid")).optional(),
        phone: $7Ilk7.string().optional(),
        partnerId: $7Ilk7.string().required()
    });
    const { handleSubmit: handleSubmit, reset: reset, register: register, formState: { isValid: isValid, isSubmitting: isSubmitting, errors: errors }, setError: setError } = (0, $cbVaW.useForm)({
        resolver: (0, $hJq0b.yupResolver)(schema, {
            abortEarly: false
        }),
        mode: "onBlur",
        reValidateMode: "onChange"
    });
    const onCancel = ()=>{
        onClose();
        reset();
    };
    const onSave = handleSubmit(async (data)=>{
        try {
            await onSubmit(data);
            onCancel();
            toast.notifySuccess(text("msgResourceCreated", {
                resource: text("lblOrganisation")
            }));
        } catch (err) {
            setError("root", {
                message: text("msgCreateCompanyError")
            });
        }
    });
    const partnerOptions = (0, $6uMv9.useMemo)(()=>partners.map((partner)=>({
                key: partner.id,
                value: partner.name
            })), [
        partners
    ]);
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: text("lblNewOrganisation"),
        actions: [
            {
                label: text("btnSave"),
                callback: onSave,
                disabled: !isValid || isSubmitting,
                loading: isSubmitting
            },
            {
                label: text("btnCancel"),
                callback: onCancel
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        name: "form",
        role: "form",
        noValidate: true
    }, errors.root?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ccB6k.Alert), {
        error: true,
        message: errors.root?.message
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        labelText: text("lblName"),
        ...register("name"),
        id: "input-name",
        error: errors.name?.message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        labelText: text("lblDescription"),
        ...register("description"),
        id: "input-description",
        error: errors.description?.message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        labelText: text("lblEmail"),
        ...register("email"),
        id: "input-email",
        error: errors.email?.message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        labelText: text("lblPhone"),
        ...register("phone"),
        id: "input-phone"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aodd6.default), {
        id: "input-partner",
        enableDefaultOption: true,
        labelText: text("lblPartnerField"),
        ...register("partnerId"),
        options: partnerOptions
    })))) : null;
};




const $87feb99acb847344$export$8acabd3b657a454 = ()=>{
    const text = (0, $aL1Vp.default)();
    const [createOrganisationModalIsOpen, setOrganisationModalIsOpen] = (0, $6uMv9.useState)(false);
    const [filter, setFilter] = (0, $6uMv9.useState)({});
    const { data: partners = [] } = (0, $fvmYM.usePartnerGetAllAllQuery)({
        excludeOrphans: false
    });
    const { data: companies = [], isLoading: isLoading } = (0, $fvmYM.useCompanyGetAllOrFilteredQuery)({
        ...filter,
        numberOfItems: 100
    }, {
        refetchOnMountOrArgChange: true
    });
    const [createCompany] = (0, $fvmYM.useCompanyCreateCompanyMutation)();
    const onClear = ()=>{
        setFilter({});
    };
    const onCreateCompany = (company)=>{
        return createCompany({
            company: company
        }).unwrap();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $813e3863f5bfdf1f$export$8df2e2fbd1e54e2a), {
        onSearch: setFilter,
        onClear: onClear
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblOrganisations"),
        headerButtons: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                label: text("btnCreate"),
                onClick: ()=>setOrganisationModalIsOpen(true),
                "data-testid": "btn-create"
            })
        ]
    }, companies.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "heading5"
    }, text("msgOrganisationsFound", {
        amount: companies.length
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8f892dda54dee436$export$2e2bcd8739ae039), {
        data: companies,
        loading: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cc6a8eaf677b7404$export$8cce66a55d513258), {
        isOpen: createOrganisationModalIsOpen,
        onClose: ()=>setOrganisationModalIsOpen(false),
        partners: partners,
        onSubmit: onCreateCompany
    }));
};





var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $174na = parcelRequire("174na");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $lWDz3 = parcelRequire("lWDz3");

var $iZaUM = parcelRequire("iZaUM");

var $blgfq = parcelRequire("blgfq");

var $hBKXa = parcelRequire("hBKXa");

var $2naDF = parcelRequire("2naDF");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $fvmYM = parcelRequire("fvmYM");

var $6Wbwp = parcelRequire("6Wbwp");

var $d6sTr = parcelRequire("d6sTr");

var $jeXdk = parcelRequire("jeXdk");

var $52Dbq = parcelRequire("52Dbq");

var $6EtzN = parcelRequire("6EtzN");

var $35vY7 = parcelRequire("35vY7");

var $6GUeO = parcelRequire("6GUeO");
var $139337fb7b5014a6$var$SortParameter;
(function(SortParameter) {
    SortParameter["ID"] = "id";
    SortParameter["NAME"] = "name";
    SortParameter["STATUS"] = "chargePointStatus";
    SortParameter["ORGANISATION"] = "companyName";
})($139337fb7b5014a6$var$SortParameter || ($139337fb7b5014a6$var$SortParameter = {}));
// pick only allowed fields
const $139337fb7b5014a6$var$mapSearchParamsToFilter = ({ id: id, companyId: companyId, status: status, name: name, ownerEmail: ownerEmail, imsiNumber: imsiNumber, installedFirmwareVersion: installedFirmwareVersion, ownerName: ownerName, ownerMobile: ownerMobile, ocppOnly: ocppOnly, partnerId: partnerId, productId: productId })=>{
    return {
        id: id,
        companyId: companyId,
        status: status,
        name: name,
        ownerEmail: ownerEmail,
        imsiNumber: imsiNumber,
        installedFirmwareVersion: installedFirmwareVersion,
        ownerName: ownerName,
        ownerMobile: ownerMobile,
        ocppOnly: ocppOnly,
        partnerId: partnerId,
        productId: productId
    };
};
const $139337fb7b5014a6$export$b299b66281555f68 = (0, $akcQ4.default)((0, $lWDz3.FontAwesomeIcon))`
    margin-left: 4px;
`;
const $139337fb7b5014a6$export$662e7dca465a6887 = /*#__PURE__*/ (0, $6uMv9.memo)(function ChargePointsPage({ className: className, style: style }) {
    const [sortFilter, setSortFilter] = (0, $6uMv9.useState)({
        parameter: "id",
        reversed: true
    });
    const [searchParams, setParams] = (0, $iZaUM.useSearchParams)();
    const params = Object.fromEntries(searchParams.entries());
    const filter = $139337fb7b5014a6$var$mapSearchParamsToFilter(params);
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [pageSize, setPageSize] = (0, $6uMv9.useState)(20);
    const { currentData: chargePointsData, isFetching: dataLoading } = (0, $fvmYM.useChargePointGetChargePointsQuery)({
        id: filter.id,
        name: filter.name,
        status: filter.status,
        companyId: filter.companyId,
        imsiNumber: filter.imsiNumber,
        installedFirmwareVersion: filter.installedFirmwareVersion,
        partnerId: filter.partnerId,
        productId: filter.productId,
        ownerName: filter.ownerName,
        ownerEmail: filter.ownerEmail,
        ownerMobile: filter.ownerMobile,
        ocppOnly: filter.ocppOnly,
        page: currentPage,
        noOfItems: pageSize,
        expand: (0, $6Wbwp.default).OcppConfig
    });
    const filterSubmit = (filter)=>{
        setParams((0, $blgfq.pickBy)(filter, (value)=>value !== undefined && value !== null));
        if (currentPage !== 0) setCurrentPage(0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "table-charge-points",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))("flex-1", className),
        style: style,
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6EtzN.ChargePointsSearchWidget), {
            onSubmit: filterSubmit,
            filter: filter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6GUeO.default), {
        amount: chargePointsData?.totalCount,
        isLoading: dataLoading,
        pageSize: pageSize,
        setCurrentPage: setCurrentPage,
        setPageSize: setPageSize
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        className: "flex-1",
        isLoading: dataLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "th-charge-points-serial-number"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        "data-testid": "table-th-serial-link",
        onClick: ()=>setSortFilter({
                parameter: "id",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSerialNumberShort"
    }), sortFilter?.parameter === "id" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($139337fb7b5014a6$export$b299b66281555f68, {
        "data-testid": "icon-sn",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "th-charge-points-status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        "data-testid": "table-th-charge-points-name-link",
        onClick: ()=>setSortFilter({
                parameter: "chargePointStatus",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblStatus"
    }), sortFilter?.parameter === "chargePointStatus" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($139337fb7b5014a6$export$b299b66281555f68, {
        "data-testid": "icon-sn",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "th-charge-points-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        onClick: ()=>setSortFilter({
                parameter: "name",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    }), sortFilter?.parameter === "name" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($139337fb7b5014a6$export$b299b66281555f68, {
        "data-testid": "icon-sn",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "th-charge-points-organisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        onClick: ()=>setSortFilter({
                parameter: "companyName",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblOrganisation"
    }), sortFilter?.parameter === "companyName" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($139337fb7b5014a6$export$b299b66281555f68, {
        "data-testid": "icon-sn",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "th-charge-points-wifi-pwd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSetWifiPassword"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "th-charge-points-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSettings"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "th-charge-points-fw-version"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblFWVersion"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), {
        isLoading: dataLoading,
        numberOfLoadingColumns: 7
    }, Array.from(chargePointsData?.items ?? []).sort((a, b)=>(0, $hBKXa.sortByString)(a[sortFilter.parameter] ?? "", b[sortFilter.parameter] ?? "", sortFilter.reversed)).map((cp)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: cp.id,
            "data-testid": "table-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            className: "pointer table btn-link",
            "data-testid": `tb-${cp.id}`,
            to: `/chargepoints/${cp.id}`
        }, cp.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jeXdk.ChargepointStatus), {
            chargePoint: cp
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `tb-${cp.name}`
        }, cp.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `tb-${cp.companyId}`
        }, cp.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "tb-wifipwd"
        }, cp.wifiPassword), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "tb-settingsinfo"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d6sTr.default), {
            chargePoint: cp
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "tb-fwVersion"
        }, cp.installedFirmwareVersion))))), chargePointsData && (chargePointsData?.totalCount ?? 0) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        setPageIndex: setCurrentPage,
        totalCount: chargePointsData?.totalCount ?? 0,
        pageSize: pageSize,
        pageIndex: currentPage,
        displayedChargers: pageSize
    })));
});





var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $84v65 = parcelRequire("84v65");

var $4HY83 = parcelRequire("4HY83");

var $fvmYM = parcelRequire("fvmYM");

var $k0EDO = parcelRequire("k0EDO");

var $aL1Vp = parcelRequire("aL1Vp");

var $1xw2Y = parcelRequire("1xw2Y");

var $k2Irz = parcelRequire("k2Irz");

var $fVJEu = parcelRequire("fVJEu");

var $9kprt = parcelRequire("9kprt");
const $6675abd5d53207a0$var$SBackButtonWrapper = (0, $akcQ4.default).div`
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
`;
const $6675abd5d53207a0$var$SExternalChargerMessageWrapper = (0, $akcQ4.default).div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
`;
const $6675abd5d53207a0$var$SExternalChargerMessage = (0, $akcQ4.default).div`
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
    text-align: center;
    width: 310px;
`;
const $6675abd5d53207a0$var$SContainer = (0, $akcQ4.default).div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    background-color: #ffffff;
    border: none;

    @media (min-width: 990px) {
        width: 90vw;
        max-width: 1400px;
    }
`;
function $6675abd5d53207a0$export$201cc43952975304() {
    const text = (0, $aL1Vp.default)();
    const { chargePointId: chargePointId } = (0, $84v65.useParams)();
    const { data: chargePoint, isLoading: isLoading } = (0, $fvmYM.useChargePointGetQuery)({
        chargePointId: chargePointId,
        expand: "additionalInfo,scheduleInfo"
    }, {
        skip: !chargePointId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($6675abd5d53207a0$var$SContainer, null, chargePoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4HY83.ChargePointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9kprt.ChargePointPageControls), {
        chargePoint: chargePoint
    }), chargePoint?.ocppServerMode === "None" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k2Irz.ChargePointCapiPage), {
        chargePoint: chargePoint,
        isLoading: isLoading
    }), chargePoint?.ocppServerMode === "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fVJEu.ChargePointOcppPage), {
        chargePoint: chargePoint,
        isLoading: isLoading
    }), chargePoint?.ocppServerMode === "External" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($6675abd5d53207a0$var$SBackButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
        title: text("btnBack"),
        onClick: ()=>window.history.back()
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($6675abd5d53207a0$var$SExternalChargerMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($6675abd5d53207a0$var$SExternalChargerMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgChargerIsDeployedToExternalPart",
        values: {
            chargePointId: chargePoint.id
        }
    })))))) : null);
}





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $174na = parcelRequire("174na");

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $cbVaW = parcelRequire("cbVaW");

var $iZaUM = parcelRequire("iZaUM");

var $fvmYM = parcelRequire("fvmYM");

var $cGtAV = parcelRequire("cGtAV");

var $8gLAc = parcelRequire("8gLAc");

var $1xw2Y = parcelRequire("1xw2Y");

var $f7UZA = parcelRequire("f7UZA");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $ka0YZ = parcelRequire("ka0YZ");

var $1xw2Y = parcelRequire("1xw2Y");

var $ccB6k = parcelRequire("ccB6k");

var $gfjRp = parcelRequire("gfjRp");

var $cGtAV = parcelRequire("cGtAV");

var $k0EDO = parcelRequire("k0EDO");

var $bhqzv = parcelRequire("bhqzv");
function $56aa9833bd592c5d$export$22ace2d0dc3ffef4(partner) {
    return (0, $bhqzv.default).post({
        path: "/partners/",
        body: partner
    });
}





var $4HVy7 = parcelRequire("4HVy7");

var $4WjE8 = parcelRequire("4WjE8");

var $aL1Vp = parcelRequire("aL1Vp");
const $dca2b106397e567a$var$SInputForm = (0, $akcQ4.default).label`
    width: 100%;
    padding-bottom: 15px;
`;
const $dca2b106397e567a$export$9724cdbdf2f45bfa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function CreatePartnerModal({ onAddPartner: onAddPartner, className: className, style: style, close: close }) {
    const text = (0, $aL1Vp.default)();
    const { value: partner, apply: apply } = (0, $gfjRp.default)({
        name: "",
        description: "",
        email: "",
        phone: "",
        hostName: ""
    });
    const [saveError, setSaveError] = (0, $6uMv9.useState)("");
    const isEmailValid = (0, $6uMv9.useMemo)(()=>partner.email ? (0, $4HVy7.validateEmailFormat)(partner.email) : true, [
        partner.email
    ]);
    const isHostNameValid = (0, $6uMv9.useMemo)(()=>partner.hostName ? (0, $4WjE8.validateHostNameFormat)(partner.hostName) : true, [
        partner.hostName
    ]);
    const { execute: createPartner, status: partnerCreatingStatus } = (0, $ka0YZ.default)(()=>(0, $56aa9833bd592c5d$export$22ace2d0dc3ffef4)(partner).then(()=>{
            onAddPartner();
            close();
        }).catch(()=>setSaveError(text("msgPartnerCouldNotBeSaved"))), [
        partner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        onSubmit: (event)=>{
            event.preventDefault();
            createPartner();
        },
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-header",
        "data-testid": "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblNewPartnerModal"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-body"
    }, saveError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ccB6k.Alert), {
        error: true,
        message: saveError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($dca2b106397e567a$var$SInputForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblNameField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        value: partner.name,
        onChange: (event)=>apply({
                name: event.target.value
            }),
        "data-testid": "nameField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($dca2b106397e567a$var$SInputForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblDescriptionField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        value: partner.description,
        onChange: (event)=>apply({
                description: event.target.value
            }),
        "data-testid": "descriptionField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($dca2b106397e567a$var$SInputForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmailField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        value: partner.email,
        onChange: (event)=>apply({
                email: event.target.value
            }),
        "data-testid": "emailField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($dca2b106397e567a$var$SInputForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPhoneField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        value: partner.phone,
        onChange: (event)=>apply({
                phone: event.target.value
            }),
        "data-testid": "phoneField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($dca2b106397e567a$var$SInputForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblHostNameField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        value: partner.hostName,
        onChange: (event)=>apply({
                hostName: event.target.value
            }),
        "data-testid": "hostNameField",
        error: !isHostNameValid
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "padding-top-15"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblExampleField"
    })), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, "my.charge.space")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
        type: "submit",
        disabled: partnerCreatingStatus === (0, $ka0YZ.Status).PENDING || !partner.description || !partner.name || !isHostNameValid || !partner.hostName || !isEmailValid,
        title: text("btnSave"),
        loading: partnerCreatingStatus === (0, $ka0YZ.Status).PENDING,
        dataTestId: "btn-save"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
        onClick: close,
        title: text("btnCancel"),
        dataTestId: "btn-cancel"
    })));
});





var $2naDF = parcelRequire("2naDF");

var $3YfCm = parcelRequire("3YfCm");

var $35vY7 = parcelRequire("35vY7");

var $aL1Vp = parcelRequire("aL1Vp");
const $d6106f03dcf1de52$var$SSearchForm = (0, $akcQ4.default).div`
    padding-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (min-width: 990px) {
        width: 55%;
    }
`;
const $d6106f03dcf1de52$var$SSearchContainer = (0, $akcQ4.default).form`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;
const $d6106f03dcf1de52$var$SRow = (0, $akcQ4.default).div`
    display: flex;
    justify-content: space-between;
    max-width: 200px;
    margin-bottom: 40px;
`;
const $d6106f03dcf1de52$var$partnerFilterInitialValues = {
    name: "",
    email: ""
};
const $d6106f03dcf1de52$export$c109ad68a15b187 = /*#__PURE__*/ (0, $6uMv9.memo)(function PartnersListWidget({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const [pageSize] = (0, $6uMv9.useState)(50);
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [filter, setFilter] = (0, $6uMv9.useState)({
        name: "",
        email: ""
    });
    const { currentData: partnersData, refetch: refetchPartners, isFetching: gettingPartners } = (0, $fvmYM.usePartnerGetAllQuery)({
        noOfItems: pageSize,
        excludeOrphans: false,
        page: currentPage,
        ...filter
    });
    const [isCreatePartnerModalOpened, setIsCreatePartnerModalOpened] = (0, $6uMv9.useState)(false);
    const { handleSubmit: handleSubmit, register: register, reset: reset } = (0, $cbVaW.useForm)({
        defaultValues: $d6106f03dcf1de52$var$partnerFilterInitialValues
    });
    const onSubmit = (data)=>{
        setCurrentPage(0);
        setFilter(data);
    };
    const handleClearSearch = ()=>{
        reset();
        setFilter($d6106f03dcf1de52$var$partnerFilterInitialValues);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblPartnersWidget"),
        "data-testid": "partners"
    }, isCreatePartnerModalOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dca2b106397e567a$export$9724cdbdf2f45bfa), {
        onAddPartner: refetchPartners,
        close: ()=>setIsCreatePartnerModalOpened(false)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d6106f03dcf1de52$var$SSearchContainer, {
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d6106f03dcf1de52$var$SSearchForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        ...register("name"),
        className: "margin-right-small",
        "data-testid": "search-name-field",
        placeholder: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        ...register("email"),
        "data-testid": "search-email-field",
        placeholder: text("lblEmail")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d6106f03dcf1de52$var$SRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        label: text("btnSearch"),
        minWidth: "95px",
        "data-testid": "btn-search",
        size: "sm",
        className: "margin-right-small",
        type: "submit"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        label: text("btnClear"),
        minWidth: "95px",
        size: "sm",
        onClick: handleClearSearch
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
        "data-testid": "table-header-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "desc"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAddress"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmail"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "phone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPhone"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "host-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblHostName"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, !gettingPartners ? partnersData?.items?.map((partner)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            className: "clickable",
            key: `row-${"partner-"}${partner.id}`,
            "data-testid": `row-${"partner-"}${partner.id}`,
            onClick: ()=>navigate(`/partner/${partner.id}`)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "name-" + partner.id
        }, partner.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "desc-" + partner.id
        }, partner.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "email-" + partner.id
        }, partner.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "phone-" + partner.id
        }, partner.phone), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "host-name-" + partner.id
        }, partner.hostName))) : null)), (partnersData?.totalCount ?? false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        pageIndex: currentPage,
        setPageIndex: (pageIndex)=>{
            window.scrollTo(0, 0);
            setCurrentPage(pageIndex);
        },
        totalCount: partnersData?.totalCount ?? 0,
        pageSize: pageSize,
        displayedChargers: pageSize
    }), gettingPartners && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-large"
    }));
});




const $982e512e279efadd$var$SContainer = (0, $akcQ4.default).div`
    width: 96%;
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 15px;
`;
const $982e512e279efadd$export$10085bc1d6e24c50 = /*#__PURE__*/ (0, $6uMv9.memo)(function PartnersPage({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($982e512e279efadd$var$SContainer, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d6106f03dcf1de52$export$c109ad68a15b187), null));
});





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $ka0YZ = parcelRequire("ka0YZ");

var $174na = parcelRequire("174na");

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $ka0YZ = parcelRequire("ka0YZ");

var $4KUHa = parcelRequire("4KUHa");

var $gfjRp = parcelRequire("gfjRp");

var $1xw2Y = parcelRequire("1xw2Y");

var $k0EDO = parcelRequire("k0EDO");

var $cGtAV = parcelRequire("cGtAV");

var $bhqzv = parcelRequire("bhqzv");
function $d7b1b26c8dd6d558$export$6af6109222273956(partner) {
    return (0, $bhqzv.default).put({
        path: "/partners",
        body: partner
    });
}





var $6N5PZ = parcelRequire("6N5PZ");

var $3YfCm = parcelRequire("3YfCm");

var $aL1Vp = parcelRequire("aL1Vp");
const $a7bbd4101173e769$var$SActions = (0, $akcQ4.default).div`
    display: flex;
    justify-content: right;
`;
function $a7bbd4101173e769$export$9c223da174fa8ac({ partner: origin, className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const { value: partner, apply: apply, set: set } = (0, $gfjRp.default)(origin);
    (0, $6uMv9.useEffect)(()=>set(origin), [
        origin
    ]);
    const [error, setError] = (0, $6uMv9.useState)("");
    const [message, setMessage] = (0, $6uMv9.useState)("");
    const isHostNameValid = (0, $6uMv9.useMemo)(()=>partner.hostName ? (0, $6N5PZ.validateHostNameFormat)(partner.hostName) : true, [
        partner.hostName
    ]);
    const { execute: execute, status: status } = (0, $ka0YZ.default)(()=>{
        setError("");
        setMessage("");
        return (0, $d7b1b26c8dd6d558$export$6af6109222273956)(partner).then(()=>setMessage(text("msgPartnerUpdated"))).catch(()=>setError(text("msgCouldNotUpdatePartner")));
    }, [
        partner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblPartnerDetailsWidget", {
            partnerName: partner.name
        }),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        loadingStatus: status === (0, $ka0YZ.Status).PENDING,
        "data-testid": "PartnerDetailsId"
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4KUHa.SAlert), {
        type: "error",
        "data-testid": "errorMsg"
    }, error), message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4KUHa.SAlert), {
        type: "success",
        "data-testid": "successMsg"
    }, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SFormRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblNameField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        name: "name",
        id: "name",
        "data-testid": "name",
        value: partner.name || "",
        onChange: (event)=>apply({
                name: event.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SFormRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAddress"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        "data-testid": "description",
        name: "description",
        id: "description",
        value: partner.description || "",
        onChange: (event)=>apply({
                description: event.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SFormRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmailField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        "data-testid": "email",
        name: "email",
        id: "email",
        value: partner.email || "",
        onChange: (event)=>apply({
                email: event.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SFormRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "phone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPhoneField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        "data-testid": "phone",
        name: "phone",
        id: "phone",
        value: partner.phone || "",
        onChange: (event)=>apply({
                phone: event.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SFormRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "hostName"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblHostNameField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        "data-testid": "hostName",
        name: "hostName",
        id: "hostName",
        value: partner.hostName || "",
        onChange: (event)=>apply({
                hostName: event.target.value
            }),
        error: !isHostNameValid
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "padding-top-15"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblExampleField"
    })), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, "my.charge.space"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($a7bbd4101173e769$var$SActions, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
        "data-testId": "btn-save",
        title: text("btnSave"),
        onClick: execute,
        disabled: !isHostNameValid || !partner.hostName || status === (0, $ka0YZ.Status).PENDING,
        dataTestId: "savePartnerDetails"
    })));
}






var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $lWDz3 = parcelRequire("lWDz3");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $k0EDO = parcelRequire("k0EDO");

var $1xw2Y = parcelRequire("1xw2Y");

var $3YfCm = parcelRequire("3YfCm");

var $hBKXa = parcelRequire("hBKXa");

var $cGtAV = parcelRequire("cGtAV");

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $ka0YZ = parcelRequire("ka0YZ");

var $bhqzv = parcelRequire("bhqzv");
const $f2ad5ea334d0f6ca$var$loadPartners = ()=>(0, $bhqzv.default)({
        path: `/partners`
    });
var $f2ad5ea334d0f6ca$export$2e2bcd8739ae039 = $f2ad5ea334d0f6ca$var$loadPartners;



var $1xw2Y = parcelRequire("1xw2Y");

var $lG0u6 = parcelRequire("lG0u6");

var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");
const $4bb0a8bc0cf6a9f1$var$SWrapper = (0, $akcQ4.default).div`
    @media (max-width: 900px) {
        padding: 10px 20px;
    }
`;
const $4bb0a8bc0cf6a9f1$var$SColumnTitle = (0, $akcQ4.default).th`
    font-weight: 400;
    font-size: 12px;
    font-weight: 700;
    border: 0;
    padding: 6px 10px;
    text-align: ${({ centered: centered })=>centered ? "center" : "start"};
    background-color: white;
    border-bottom: 1px solid #dddddd;
`;
const $4bb0a8bc0cf6a9f1$var$SContainer = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    align-items: ${({ center: center })=>center ? "center" : "flex-start"};
`;
const $4bb0a8bc0cf6a9f1$var$SSelectedOrganisations = (0, $akcQ4.default).div`
    font-size: 16px;
    font-weight: 400;
    padding-bottom: 16px;
`;
const $4bb0a8bc0cf6a9f1$var$SSelectPartnerLabel = (0, $akcQ4.default).label`
    display: block;
    font-size: 16px;
    font-weight: 350;
`;
const $4bb0a8bc0cf6a9f1$var$SInput = (0, $akcQ4.default).input`
    flex: 1;
    margin-right: 10px;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1em;
    color: #555;
    font-weight: 300;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
`;
const $4bb0a8bc0cf6a9f1$var$SSelectPartner = (0, $akcQ4.default).div`
    width: 100%;
    padding-bottom: 20px;
`;
const $4bb0a8bc0cf6a9f1$var$SActions = (0, $akcQ4.default).div`
    width: 100%;
    display: flex;
    gap: 16px;
    justify-content: ${({ centered: centered })=>centered ? "center" : "flex-end"};
    justify-content: flex-end;
    padding: 20px 0 0;
`;
const $4bb0a8bc0cf6a9f1$var$SFixedHeadTableWrapper = (0, $akcQ4.default).div`
    width: 100%;
    min-height: 70px;
    max-height: 400px;
    overflow-y: auto;

    & thead th {
        position: sticky;
        top: 0px;
    }
`;
const $4bb0a8bc0cf6a9f1$var$SPartnersTable = (0, $akcQ4.default).table`
    margin-bottom: 20px;
    border-collapse: collapse;
    width: 100%;
`;
const $4bb0a8bc0cf6a9f1$var$SHead = (0, $akcQ4.default).thead``;
const $4bb0a8bc0cf6a9f1$var$STableRow = (0, $akcQ4.default).tr`
    cursor: pointer;
    border-bottom: 1px solid #dddddd;

    :nth-child(odd) {
        background: #f5f5f5;
    }
`;
const $4bb0a8bc0cf6a9f1$var$SConfirmationText = (0, $akcQ4.default).div`
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    max-width: 390px;
    padding-bottom: 8px;
`;
const $4bb0a8bc0cf6a9f1$var$SSuccessText = (0, $akcQ4.default).p`
    margin: 0;
    padding-bottom: 66px;
    font-size: 16px;
    font-weight: 400;
`;
const $4bb0a8bc0cf6a9f1$var$SConfirmationSubtext = (0, $akcQ4.default).p`
    text-align: center;
    margin: 0;
    max-width: 350px;
    font-size: 14px;
    font-weight: 350;
    padding-bottom: 36px;
`;
const $4bb0a8bc0cf6a9f1$var$SIcon = (0, $akcQ4.default).svg`
    margin: 28px 0;
`;
const $4bb0a8bc0cf6a9f1$var$SHeader = (0, $akcQ4.default).h3`
    font-size: 24px;
    font-weight: 500;
    padding-bottom: 16px;
    font-family: ${({ theme: theme })=>theme.font.extendedName};
    margin: 0;
`;
const $4bb0a8bc0cf6a9f1$var$SColumnCell = (0, $akcQ4.default).td`
    font-size: 14px;
    font-weight: 300;
    padding: 7px 10px 15px 10px;
    vertical-align: top;
    text-align: ${({ centered: centered })=>centered ? "center" : "start"};
`;
const $4bb0a8bc0cf6a9f1$var$SSearchPartnerForm = (0, $akcQ4.default).form`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
`;
const $4bb0a8bc0cf6a9f1$var$Wrapper = ({ children: children, center: center })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SHeader, {
        "data-testid": "moveOrgTitle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblMoveOrganisation"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SContainer, {
        center: center
    }, children));
var $4bb0a8bc0cf6a9f1$var$Step;
(function(Step) {
    Step["SELECT_ACCOUNT"] = "SelectAccount";
    Step["CONFIRMATION"] = "Confirmation";
    Step["SUCCESS"] = "Success";
})($4bb0a8bc0cf6a9f1$var$Step || ($4bb0a8bc0cf6a9f1$var$Step = {}));
function $4bb0a8bc0cf6a9f1$export$94f5f33fd3286a97({ organisations: organisations, close: close, currentPartner: currentPartner, onMove: onMove }) {
    const text = (0, $aL1Vp.default)();
    const [step, setStep] = (0, $6uMv9.useState)("SelectAccount");
    const [partnerId, setPartnerId] = (0, $6uMv9.useState)("");
    const [searchedPartners, setSearchedPartners] = (0, $6uMv9.useState)([]);
    const [selectedPartner, setSelectedPartner] = (0, $6uMv9.useState)(null);
    const [isFirstSearchCompleted, setIsFirstSearchCompleted] = (0, $6uMv9.useState)(false);
    const [movedOrganisations, setMovedOrganisations] = (0, $6uMv9.useState)(0);
    const [batchTransfer] = (0, $fvmYM.useCompanyTransferBatchTransferMutation)();
    const { value: allPartners } = (0, $ka0YZ.default)((0, $f2ad5ea334d0f6ca$export$2e2bcd8739ae039), [], []);
    const moveOrganisations = (selectedPartnerId)=>{
        return batchTransfer({
            body: organisations.map((organisation)=>organisation.id),
            partnerId: selectedPartnerId
        }).unwrap();
    };
    const searchPartner = ()=>{
        setIsFirstSearchCompleted(true);
        setSearchedPartners(allPartners?.filter((partner)=>partner.id !== currentPartner.id).filter((partner)=>partner.id === +partnerId || partner.name.toLocaleLowerCase().includes(partnerId.toLocaleLowerCase())) || []);
    };
    switch(step){
        case "SelectAccount":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SSelectedOrganisations, {
                "data-testid": "moveOrgInfo"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "lblOrganisationsSelected",
                values: {
                    numberOfOrganisations: organisations.length
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SSelectPartner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SSelectPartnerLabel, {
                htmlFor: "accountName",
                "data-testid": "selectOrgTitle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "lblSelectPartnerAccount"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SSearchPartnerForm, {
                onSubmit: (event)=>{
                    event.preventDefault();
                    searchPartner();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SInput, {
                placeholder: text("lblPartnerField"),
                value: partnerId,
                onChange: (event)=>setPartnerId(event.target.value),
                "data-testid": "moveOrgInput"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                size: "sm",
                type: "submit",
                disabled: !partnerId.trim(),
                "data-testid": "searchBtn"
            }, text("btnSearch")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SFixedHeadTableWrapper, null, searchedPartners.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SPartnersTable, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SHead, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnTitle, {
                width: "10%",
                "data-testid": "theadId"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "lblId"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnTitle, {
                width: "40%",
                "data-testid": "theadName"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "lblName"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnTitle, {
                width: "30%",
                "data-testid": "theadDesc"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "lblDescription"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnTitle, {
                width: "20%",
                centered: true,
                "data-testid": "theadSelect"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "lblSelect"
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("tbody", null, searchedPartners.map((partner)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$STableRow, {
                    key: Math.random(),
                    onClick: ()=>setSelectedPartner(partner)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnCell, {
                    "data-testid": "partner-" + partner.id
                }, partner.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnCell, {
                    "data-testid": "partnerName-" + partner.id
                }, partner.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnCell, {
                    "data-testid": "partnerDesc-" + partner.id
                }, partner.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SColumnCell, {
                    centered: true,
                    "data-testid": "partnerIcon-" + partner.id
                }, selectedPartner?.id === partner.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: 15,
                    height: 12,
                    fill: "none"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.243.264a1 1 0 0 0-1.413.06l-6.876 7.48-2.54-2.54a1 1 0 0 0-1.414 0l-.707.706a1 1 0 0 0 0 1.414L4.308 11.4a1 1 0 0 0 1.443-.03l8.288-9.017a1 1 0 0 0-.06-1.412l-.736-.677Z",
                    fill: (0, $lG0u6.theme).brandColors.CA_Green
                }))))))) : isFirstSearchCompleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "msgNoSearchResult"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SActions, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                size: "sm",
                primary: false,
                onClick: close,
                "data-testid": "cancelBtn"
            }, text("btnCancel")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                size: "sm",
                onClick: ()=>setStep("Confirmation"),
                disabled: !selectedPartner,
                "data-testid": "moveBtn"
            }, text("btnMove"))));
        case "Confirmation":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$Wrapper, {
                center: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SIcon, {
                xmlns: "http://www.w3.org/2000/svg",
                width: 60,
                height: 60
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("g", {
                clipPath: "url(#a)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
                d: "m31.77 19-.71.71 9.73 9.73H18v1h22.79l-9.74 9.74.71.71 10.95-10.95L31.77 19Z",
                fill: "#81E18B"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30 .984C13.975.984.984 13.974.984 30c0 16.025 12.99 29.016 29.016 29.016 16.025 0 29.016-12.99 29.016-29.016C59.016 13.975 46.026.984 30 .984ZM0 30C0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30Z",
                fill: "#81E18B"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("clipPath", {
                id: "a"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
                fill: "#fff",
                transform: "translate(18 19)",
                d: "M0 0h24.71v21.89H0z"
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SConfirmationText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "msgMoveOrganisationsConfirmation",
                values: {
                    numberOfOrganisations: organisations.length,
                    currentPartnerName: currentPartner.name,
                    selectedPartnerName: selectedPartner?.name
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SConfirmationSubtext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "msgAllChargersAndRFIDsWillBeMovedTogether"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SActions, {
                centered: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                size: "sm",
                primary: false,
                onClick: ()=>setStep("SelectAccount")
            }, text("btnBack")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                size: "sm",
                onClick: async ()=>{
                    if (!selectedPartner) return;
                    try {
                        await moveOrganisations(selectedPartner.id);
                        setMovedOrganisations(organisations.length);
                        (0, $2460e.notifySuccess)(text("msgOrganisationTransferSuccess"));
                        setStep("Success");
                        onMove();
                    } catch (error) {
                        (0, $2460e.notifyError)(text("msgOrganisationTransferFailure"));
                    }
                },
                "data-testid": "btnYes"
            }, text("btnYes"))));
        case "Success":
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$Wrapper, {
                center: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SIcon, {
                xmlns: "http://www.w3.org/2000/svg",
                width: 60,
                height: 60,
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M46.253 20.02 24.929 41.343l-5.604-5.613.696-.695 4.909 4.917 20.627-20.627.696.695Zm-28.62 14.016-3.718-3.725.696-.695 3.719 3.725-.696.695Z",
                fill: "#81E18B"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30 .984C13.975.984.984 13.974.984 30c0 16.025 12.99 29.016 29.016 29.016 16.025 0 29.016-12.99 29.016-29.016C59.016 13.975 46.026.984 30 .984ZM0 30C0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30Z",
                fill: "#81E18B"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SSuccessText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "msgOrganisationsMoved",
                values: {
                    numberOfOrganisations: movedOrganisations
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4bb0a8bc0cf6a9f1$var$SActions, {
                centered: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                size: "sm",
                onClick: close,
                "data-testid": "btnClose"
            }, text("btnClose"))));
    }
}





var $8gLAc = parcelRequire("8gLAc");
parcelRequire("acee3");
var $6IEar = parcelRequire("6IEar");

var $2naDF = parcelRequire("2naDF");

var $dXUkh = parcelRequire("dXUkh");

var $aL1Vp = parcelRequire("aL1Vp");
const $4c28140249159c5a$var$SSearchForm = (0, $akcQ4.default).div`
    padding-bottom: 20px;
    width: 100%;

    @media (min-width: 900px) {
        width: 30%;
    }
`;
const $4c28140249159c5a$var$SOrganisation = (0, $akcQ4.default).div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
const $4c28140249159c5a$var$SIcon = (0, $akcQ4.default)((0, $lWDz3.FontAwesomeIcon))`
    margin-left: 4px;
`;
const $4c28140249159c5a$var$SCustomCheckboxContainer = (0, $akcQ4.default).div`
    width: 16px;
    display: inline-block;
`;
const $4c28140249159c5a$var$SCustomCheckbox = (0, $akcQ4.default).input`
    appearance: none;
    position: relative;

    &:checked:after {
        background-color: #0075ff;
        border-color: #0033a0;
    }

    &:checked:before {
        border-color: #ffffff;
    }

    &:after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 14px;
        height: 14px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f8f8f8;
    }

    &:before {
        content: '';
        position: absolute;
        width: 8px;
        height: 5px;
        border-bottom: 2px solid #f8f8f8;
        z-index: 1;
        left: 3px;
        bottom: 4px;
        transform: rotate(312deg);
        border-left: 2px solid #f8f8f8;
    }

    ${({ dashed: dashed })=>{
    if (!dashed) return;
    return `&:before {
            transform: none;
            border-left: none;
        }`;
}}
`;
var $4c28140249159c5a$var$SortParameter;
(function(SortParameter) {
    SortParameter["NAME"] = "name";
    SortParameter["DESCRIPTION"] = "description";
    SortParameter["EMAIL"] = "email";
    SortParameter["PHONE"] = "phone";
})($4c28140249159c5a$var$SortParameter || ($4c28140249159c5a$var$SortParameter = {}));
const $4c28140249159c5a$export$e56f9c6a180c5bc2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function PartnerOrganisationsWidget({ partner: partner, reload: reload, organisations: organisations, className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [search, setSearch] = (0, $6uMv9.useState)("");
    const [selectedOrganisations, setSelectedOrganisations] = (0, $6uMv9.useState)([]);
    const [isMoveOrganisationsModalOpened, setIsMoveOrganisationsModalOpened] = (0, $6uMv9.useState)(false);
    const [sortFilter, setSortFilter] = (0, $6uMv9.useState)({
        parameter: "name"
    });
    const selectAllOrganisations = ()=>{
        if (!organisations || selectedOrganisations.length === organisations.length) {
            setSelectedOrganisations([]);
            return;
        }
        setSelectedOrganisations(organisations.filter((organisation)=>(0, $6IEar.filterFieldsBySearchValue)([
                organisation.name,
                organisation.description,
                organisation.email || "",
                organisation.phone
            ], search)));
    };
    const selectOrganisation = (organisation)=>{
        if (selectedOrganisations.includes(organisation)) {
            setSelectedOrganisations(selectedOrganisations.filter((org)=>org.id !== organisation.id));
            return;
        }
        setSelectedOrganisations([
            ...selectedOrganisations,
            organisation
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblOrganisations"),
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
            small: true,
            onClick: ()=>setIsMoveOrganisationsModalOpened(true),
            disabled: !selectedOrganisations.length,
            title: text("btnMove"),
            dataTestId: "moveOrganisationBtn"
        }),
        "data-testid": "partnerOrganisation"
    }, isMoveOrganisationsModalOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4bb0a8bc0cf6a9f1$export$94f5f33fd3286a97), {
        close: ()=>setIsMoveOrganisationsModalOpened(false),
        organisations: selectedOrganisations,
        currentPartner: partner,
        onMove: ()=>{
            setSelectedOrganisations([]);
            reload();
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SSearchForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cGtAV.SInput), {
        value: search,
        onChange: (event)=>setSearch(event.target.value),
        placeholder: text("lblSearchField")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SOrganisation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SCustomCheckboxContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SCustomCheckbox, {
        type: "checkbox",
        onChange: selectAllOrganisations,
        dashed: !!selectedOrganisations.length && !!organisations && selectedOrganisations.length < organisations.length,
        checked: !!selectedOrganisations.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
        onClick: ()=>setSortFilter({
                parameter: "name",
                reversed: !sortFilter?.reversed
            }),
        "data-testid": "nameLabel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    }), sortFilter?.parameter === "name" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
        onClick: ()=>setSortFilter({
                parameter: "description",
                reversed: !sortFilter?.reversed
            }),
        "data-testid": "descLabel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblDescription"
    }), sortFilter?.parameter === "description" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
        onClick: ()=>setSortFilter({
                parameter: "email",
                reversed: !sortFilter?.reversed
            }),
        "data-testid": "emailLabel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmail"
    }), sortFilter?.parameter === "email" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
        onClick: ()=>setSortFilter({
                parameter: "phone",
                reversed: !sortFilter?.reversed
            }),
        "data-testid": "phoneLabel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPhone"
    }), sortFilter?.parameter === "phone" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SIcon, {
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, organisations?.filter((organisation)=>(0, $6IEar.filterFieldsBySearchValue)([
            organisation.name,
            organisation.description,
            organisation.email || "",
            organisation.phone
        ], search)).sort((a, b)=>(0, $hBKXa.sortByString)(a[sortFilter.parameter] ?? "", b[sortFilter.parameter] ?? "", sortFilter.reversed)).map((organisation, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: Math.random()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SOrganisation, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SCustomCheckboxContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($4c28140249159c5a$var$SCustomCheckbox, {
            type: "checkbox",
            onChange: ()=>selectOrganisation(organisation),
            checked: selectedOrganisations.includes(organisation)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
            as: (0, $iZaUM.Link),
            to: `/company/${organisation.id}`,
            "data-testid": "org-" + i
        }, organisation.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "orgDesc-" + i
        }, organisation.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "orgEmail-" + i
        }, organisation.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "orgPhone-" + i
        }, organisation.phone))))));
});





var $bhqzv = parcelRequire("bhqzv");
const $abeded97051f7a8e$var$loadPartner = (partnerId)=>(0, $bhqzv.default)({
        path: `/partners/${partnerId}`
    });
var $abeded97051f7a8e$export$2e2bcd8739ae039 = $abeded97051f7a8e$var$loadPartner;



var $52Dbq = parcelRequire("52Dbq");

var $k0EDO = parcelRequire("k0EDO");

var $bhqzv = parcelRequire("bhqzv");
function $33dd54c738de1d48$export$7bb1334bcbf1ac59(partnerId) {
    return (0, $bhqzv.default)({
        path: `/partners/${partnerId}/users`
    });
}





var $bhqzv = parcelRequire("bhqzv");
function $bc2b41710c2383ca$export$2c57c6eb99eb9172(partnerId) {
    return (0, $bhqzv.default).del({
        path: `/partners/${partnerId}`
    });
}





var $bhqzv = parcelRequire("bhqzv");
const $631872a1c14ecb77$var$loadPartnerCompanies = (partnerId, query)=>(0, $bhqzv.default).get({
        path: `/partners/${partnerId}/companies`,
        query: query
    });
var $631872a1c14ecb77$export$2e2bcd8739ae039 = $631872a1c14ecb77$var$loadPartnerCompanies;


parcelRequire("bOBEI");
var $77EIr = parcelRequire("77EIr");

var $aL1Vp = parcelRequire("aL1Vp");
const $2cfd2106bedb9db9$var$SActions = (0, $akcQ4.default).div`
    display: flex;
    justify-content: flex-end;
    padding-bottom: 20px;
    gap: 4px;
`;
const $2cfd2106bedb9db9$export$4d779efee0ce2e52 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function PartnerPage({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const { id: partnerId } = (0, $84v65.useParams)();
    const { value: partner } = (0, $ka0YZ.default)(()=>{
        if (!partnerId) return;
        return (0, $abeded97051f7a8e$export$2e2bcd8739ae039)(partnerId);
    }, [
        partnerId
    ], []);
    const { value: users, status: usersLoadingStatus, execute: reloadUsers } = (0, $ka0YZ.default)(()=>{
        if (!partnerId) return;
        return (0, $33dd54c738de1d48$export$7bb1334bcbf1ac59)(partnerId);
    }, [
        partnerId
    ], []);
    const { value: companies, status: companiesLoadingStatus, execute: reloadCompanies } = (0, $ka0YZ.default)(()=>{
        if (!partnerId) return;
        return (0, $631872a1c14ecb77$export$2e2bcd8739ae039)(+partnerId);
    }, [
        partnerId
    ], []);
    const { execute: deletePartner } = (0, $ka0YZ.default)(()=>{
        if (!partnerId) return;
        if (!confirm(text("msgDeletePartnerConfirmation"))) return;
        return (0, $bc2b41710c2383ca$export$2c57c6eb99eb9172)(partnerId).then(()=>navigate("/partners")).catch(()=>alert(text("msgDeletePartnerFailed")));
    }, [
        partnerId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($2cfd2106bedb9db9$var$SActions, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
        small: true,
        loading: !partner || usersLoadingStatus === (0, $ka0YZ.Status).PENDING,
        title: text("btnDeletePartner"),
        onClick: deletePartner,
        tooltip: users?.length ? text("msgCannotDeletePartnerThatHasUsers") : companies?.length ? text("msgCannotDeletePartnerThatHasOrganisations") : "",
        disabled: !partner || usersLoadingStatus === (0, $ka0YZ.Status).PENDING || !!users?.length || companiesLoadingStatus === (0, $ka0YZ.Status).PENDING || !!companies?.length
    })), companiesLoadingStatus !== (0, $ka0YZ.Status).PENDING && partner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $a7bbd4101173e769$export$9c223da174fa8ac), {
        partner: partner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $603c8bfd048b6acc$export$1a45aa3975793088), {
        reload: reloadUsers,
        partnerUsers: users,
        partnerId: partner.id.toString()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4c28140249159c5a$export$e56f9c6a180c5bc2), {
        reload: reloadCompanies,
        organisations: companies,
        partner: partner
    })), companiesLoadingStatus === (0, $ka0YZ.Status).PENDING && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        title: true,
        height: "437px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        title: true,
        height: "156px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        title: true,
        headerButton: true,
        height: "338px"
    })));
});





var $6uMv9 = parcelRequire("6uMv9");

var $gnU93 = parcelRequire("gnU93");

var $52Dbq = parcelRequire("52Dbq");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");

var $6uMv9 = parcelRequire("6uMv9");

var $dRyYg = parcelRequire("dRyYg");

var $bhqzv = parcelRequire("bhqzv");
var $422a2c45da6492b2$export$2e2bcd8739ae039 = (query)=>(0, $bhqzv.default).get({
        path: "/companies",
        query: query
    });


const $6c5d5d623b3e2298$var$loadOptions = (search)=>(0, $422a2c45da6492b2$export$2e2bcd8739ae039)({
        noOfItems: 30,
        name: search
    }).then((companies)=>companies.map((company)=>({
                value: company.id,
                label: company.name
            })));
const $6c5d5d623b3e2298$var$CompanySelect = ({ onChange: onChange })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dRyYg.default), {
        cacheOptions: true,
        defaultOptions: true,
        defaultValue: null,
        loadOptions: $6c5d5d623b3e2298$var$loadOptions,
        onChange: (company)=>onChange(company?.value)
    });
};
var $6c5d5d623b3e2298$export$2e2bcd8739ae039 = $6c5d5d623b3e2298$var$CompanySelect;



var $fvmYM = parcelRequire("fvmYM");

var $8gLAc = parcelRequire("8gLAc");

var $7SnmO = parcelRequire("7SnmO");

var $8MU0a = parcelRequire("8MU0a");

var $1xw2Y = parcelRequire("1xw2Y");

var $ccB6k = parcelRequire("ccB6k");

var $9jM6q = parcelRequire("9jM6q");

var $aL1Vp = parcelRequire("aL1Vp");
const $cefcae985bb6052e$var$MeasurementDeviceCreateModal = ({ close: close, dismiss: dismiss, className: className, style: style, errorText: errorText })=>{
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const [device, setDevice] = (0, $6uMv9.useState)(()=>({
            ignoreCurrentDirection: true,
            companyId: null
        }));
    const patchDevice = (params)=>setDevice((device)=>({
                ...device,
                ...params
            }));
    const [isDeviceErrorShown, setDeviceErrorVisibility] = (0, $6uMv9.useState)(false);
    const [createNewDevice] = (0, $fvmYM.useMeasurementDevicesCreateMutation)();
    const createDevice = async ()=>{
        try {
            await createNewDevice({
                createMeasurementDeviceApiModel: device
            }).unwrap().then((payload)=>navigate(`/measurementDevice/${payload.id}`));
        } catch (e) {
            errorText();
        }
    };
    const handleSubmit = ()=>{
        if (device.type) createDevice(), close(device);
        else setDeviceErrorVisibility(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        size: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: (0, $8MU0a.default)(handleSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-header",
        "data-testid": "header-md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblCreateMeasurementDevice"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-body"
    }, isDeviceErrorShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ccB6k.Alert), {
        style: {
            margin: "15px"
        },
        error: true,
        message: text("msgChooseProductForMeasurementDevice")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        "data-testid": "lbl-name"
    }, text("lblMeasurementDeviceName")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        "data-testid": "name-input",
        type: "text",
        className: "form-control",
        value: device?.name ? device.name : "",
        onChange: (e)=>patchDevice({
                name: e?.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        "data-testid": "lbl-desc"
    }, text("lblMeasurementDeviceDescription")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "text",
        className: "form-control",
        value: device.description,
        onChange: (e)=>patchDevice({
                description: e.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        "data-testid": "lbl-detailed-desc"
    }, text("lblMeasurementDeviceDetailedDescription")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "text",
        className: "form-control",
        value: device.detailedDescription,
        onChange: (e)=>patchDevice({
                detailedDescription: e.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        "data-testid": "lbl-point"
    }, text("lblMeasurementDevicePointOfInstallation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "text",
        className: "form-control",
        value: device.pointOfInstallation,
        onChange: (e)=>patchDevice({
                pointOfInstallation: e.target.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        "data-testid": "lbl-product"
    }, text("lblMeasurementDeviceProduct")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        "data-testid": "select-product"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7SnmO.default), {
        "data-testid": "select",
        onChange: (type)=>{
            patchDevice({
                type: type
            });
            setDeviceErrorVisibility(false);
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        "data-testid": "lbl-org"
    }, text("lblMeasurementDeviceCompany")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6c5d5d623b3e2298$export$2e2bcd8739ae039), {
        onChange: (companyId)=>patchDevice({
                companyId: companyId
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9jM6q.CheckboxInput), {
        label: text("lblMeasurementDeviceIgnoreCurrentDirection"),
        checked: device.ignoreCurrentDirection,
        setChecked: (checked)=>patchDevice({
                ignoreCurrentDirection: checked
            }),
        dataTestId: "ignore-dir"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok",
        type: "submit",
        "data-testid": "btn-ok",
        disabled: !device?.name
    }, text("btnOK")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok",
        type: "button",
        onClick: ()=>dismiss(),
        "data-testid": "btn-cancel"
    }, text("btnCancel")))));
};
var $cefcae985bb6052e$export$2e2bcd8739ae039 = $cefcae985bb6052e$var$MeasurementDeviceCreateModal;



var $aL1Vp = parcelRequire("aL1Vp");
parcelRequire("9J2qy");
var $fZJUc = parcelRequire("fZJUc");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");
const $44408ddca77a08e8$var$defaultFiltersValue = {
    serialNumber: "",
    companyId: "",
    limit: 100,
    name: "",
    companyName: "",
    partnerName: "",
    productId: undefined,
    status: undefined
};
const $44408ddca77a08e8$export$8de4554fe05e44f8 = /*#__PURE__*/ (0, $6uMv9.memo)(function MeasurementDevicesPage({ style: style }) {
    const text = (0, $aL1Vp.default)();
    const [openCreateModal, setOpenCreateModal] = (0, $6uMv9.useState)(false);
    const [filter, setFilter] = (0, $6uMv9.useState)($44408ddca77a08e8$var$defaultFiltersValue);
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const filtersContainerRef = (0, $6uMv9.useRef)(null);
    const handlePageClick = (selected)=>{
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0);
        setCurrentPage(selected);
    };
    const pageClick = ()=>{
        setCurrentPage(0);
    };
    const openModal = ()=>setOpenCreateModal(true);
    const { currentData: deviceData, isFetching: deviceFetching } = (0, $fvmYM.useMeasurementDevicesGetFilteredQuery)(filter);
    const handleFilterSubmit = (filters)=>{
        setFilter({
            ...filters,
            limit: $44408ddca77a08e8$var$defaultFiltersValue.limit
        });
        pageClick();
    };
    const clearDevices = ()=>{
        setFilter($44408ddca77a08e8$var$defaultFiltersValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fZJUc.MeasurementDeviceSearchListForm), {
        onSubmit: handleFilterSubmit,
        clearDevice: clearDevices,
        loading: deviceFetching
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $gnU93.MeasurementDevicesTableWidget), {
        data: deviceData || [],
        loading: deviceFetching,
        createDevice: openModal,
        currentPage: currentPage,
        handlePageClick: handlePageClick,
        pageClick: pageClick
    }), openCreateModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cefcae985bb6052e$export$2e2bcd8739ae039), {
        errorText: ()=>(0, $2460e.notifyError)(text("msgMeasurementDeviceError")),
        close: (result)=>{
            if (result) setOpenCreateModal(false);
        },
        dismiss: ()=>setOpenCreateModal(false)
    }));
});





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $aL1Vp = parcelRequire("aL1Vp");

var $gnU93 = parcelRequire("gnU93");

var $hBKXa = parcelRequire("hBKXa");

var $2naDF = parcelRequire("2naDF");

var $35vY7 = parcelRequire("35vY7");
var $4b6cdadaee3fd2b7$var$SortParameter;
(function(SortParameter) {
    SortParameter["FIRSTNAME"] = "firstName";
})($4b6cdadaee3fd2b7$var$SortParameter || ($4b6cdadaee3fd2b7$var$SortParameter = {}));
const $4b6cdadaee3fd2b7$export$b64f0f0625b49563 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function UsersListWidget({ className: className, useractivate: useractivate, setCurrentPage: setCurrentPage, fetchingData: fetchingData, usersData: usersData, currentPage: currentPage, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [pageSize] = (0, $6uMv9.useState)(50);
    const [sortFilter, setSortFilter] = (0, $6uMv9.useState)({
        parameter: "firstName",
        reversed: false
    });
    const offset = currentPage * pageSize;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblUsersWidget"),
        "data-testid": "users"
    }, !fetchingData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "heading5 margin-bottom-10",
        "data-testid": "noOfUsers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblUsersFound",
        values: {
            users: usersData?.length
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        "data-testid": "table-th-name-link",
        onClick: ()=>setSortFilter({
                parameter: "firstName",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    }), sortFilter?.parameter === "firstName" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $gnU93.SIcon), {
        "data-testid": "icon-sn",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-email"
    }, text("lblEmail")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "table-th-status"
    }, text("lblStatus")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, usersData?.slice(offset, offset + pageSize).sort((a, b)=>(0, $hBKXa.sortByString)(a[sortFilter.parameter] ?? "", b[sortFilter.parameter] ?? "", sortFilter.reversed)).map((user)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: user?.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `table-tb-name-${user.firstName}`
        }, user.firstName, " ", user.lastName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `table-tb-name-${user.email}`
        }, user.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `table-tb-name-${user.id}`
        }, user.userStatus == "New" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            "data-testid": "table-tb-activateUser"
        }, text("lblNewUserPage")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, text("lblActivated")), user.userStatus == "New" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            "data-testid": "table-btn-activateUser",
            type: "submit",
            className: "btn btn-ok btn-sm  margin-left-med",
            onClick: ()=>useractivate(user?.id)
        }, text("btnActivate"))))))), usersData?.length > 100 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        pageIndex: currentPage,
        setPageIndex: (pageIndex)=>setCurrentPage(pageIndex),
        totalCount: usersData.length,
        pageSize: pageSize,
        displayedChargers: pageSize
    }), fetchingData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-large"
    }));
});





var $fvmYM = parcelRequire("fvmYM");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $aL1Vp = parcelRequire("aL1Vp");

var $4MH4b = parcelRequire("4MH4b");
const $04a86e006a5f05a3$export$32ed5d093883a17f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function UsersSearchListWidget({ style: style, className: className, formRef: formRef, clearForm: clearForm, onSubmit: onSubmit }) {
    const text = (0, $aL1Vp.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        "data-testid": "users-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        name: "form",
        role: "form",
        noValidate: true,
        onSubmit: onSubmit,
        ref: formRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblFirstNameSmallField"),
        "data-testid": "input-firstName",
        id: "userFirstName",
        key: "user FirstName"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblLastNameShortField"),
        "data-testid": "input-lastName",
        id: "userLastName",
        key: "user LastName"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group col-xs-12 "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblEmail"),
        "data-testid": "input-email",
        id: "userEmail",
        key: "user email"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-4 margin-top-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        className: "checkbox-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        id: "adminStatus",
        key: "admin status",
        className: "checkbox-black",
        type: "checkbox",
        "data-testid": "checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "margin-bottom-5 margin-left-xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSupportAccess"
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-4 pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok btn-sm",
        type: "submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnSearch"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok btn-sm margin-2",
        type: "button",
        "data-testid": "btn-clear",
        onClick: ()=>clearForm()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnClear"
    }))))))));
});





var $52Dbq = parcelRequire("52Dbq");

var $aL1Vp = parcelRequire("aL1Vp");
const $c2d7899b92a23b6d$var$searchFilterValue = {
    firstName: "",
    lastName: "",
    email: ""
};
const $c2d7899b92a23b6d$export$107317390f5aa598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function UsersPage({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const formRef = (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).useRef(null);
    const filtersContainerRef = (0, $6uMv9.useRef)(null);
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [activateUser] = (0, $fvmYM.useUserActivateUserMutation)({});
    const [filter, setFilter] = (0, $6uMv9.useState)({
        ...$c2d7899b92a23b6d$var$searchFilterValue
    });
    const handlePageClick = (selected)=>{
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0);
        setCurrentPage(selected);
    };
    const pageClick = ()=>{
        setCurrentPage(0);
    };
    const { currentData: usersData, refetch: refetch, isFetching: fetchingData } = (0, $fvmYM.useUserGetFilteredQuery)({
        noOfItems: 1000,
        firstName: filter?.firstName,
        lastName: filter?.lastName,
        email: filter?.email,
        isSuperAdmin: filter?.isSuperAdmin
    });
    const filterSubmit = (e)=>{
        e?.preventDefault();
        const { userFirstName: userFirstName, userLastName: userLastName, userEmail: userEmail, adminStatus: adminStatus } = e?.currentTarget.elements;
        const filterObj = {
            firstName: userFirstName?.value.length > 0 ? userFirstName.value : "",
            lastName: userLastName?.value.length > 0 ? userLastName.value : "",
            email: userEmail?.value.length > 0 ? userEmail.value : "",
            isSuperAdmin: adminStatus.checked === true ? true : undefined
        };
        setFilter({
            ...filter,
            ...filterObj
        });
        pageClick();
    };
    const clearForm = (e)=>{
        e?.preventDefault();
        formRef.current?.reset();
        setFilter({
            ...$c2d7899b92a23b6d$var$searchFilterValue
        });
    };
    const useractivate = async (userId)=>{
        if (confirm(text("msgActivateUser"))) try {
            await activateUser({
                userId: userId
            }).unwrap();
            refetch();
        } catch (e) {
            console.error(e);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $04a86e006a5f05a3$export$32ed5d093883a17f), {
        onSubmit: filterSubmit,
        clearForm: clearForm,
        formRef: formRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4b6cdadaee3fd2b7$export$b64f0f0625b49563), {
        usersData: usersData,
        currentPage: currentPage,
        handlePageClick: handlePageClick,
        pageClick: pageClick,
        setCurrentPage: setCurrentPage,
        useractivate: useractivate,
        fetchingData: fetchingData
    }));
});





var $6uMv9 = parcelRequire("6uMv9");

var $6uMv9 = parcelRequire("6uMv9");

var $cfan9 = parcelRequire("cfan9");

var $dpspD = parcelRequire("dpspD");

var $aIcGc = parcelRequire("aIcGc");

var $cFTyZ = parcelRequire("cFTyZ");

var $8N7S6 = parcelRequire("8N7S6");

var $8RYO3 = parcelRequire("8RYO3");

var $1oBYI = parcelRequire("1oBYI");

var $aL1Vp = parcelRequire("aL1Vp");
const $5b998e337471b659$export$87201ebaf33a7a54 = /*#__PURE__*/ (0, $6uMv9.memo)(function SupportApiCustomersWidget({ apiCustomers: apiCustomers, openApiCustomer: openApiCustomer, deleteCustomer: deleteCustomer, isLoading: isLoading }) {
    const text = (0, $aL1Vp.default)();
    const [globalFilter, setGlobalFilter] = (0, $6uMv9.useState)("");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cfan9.Card), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "mb-3 mt-2 flex gap-3 justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
        label: text("btnCreate"),
        onClick: ()=>openApiCustomer(undefined)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "eapi-search-input",
        type: "search",
        className: "w-3",
        "data-testid": "search",
        value: globalFilter,
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("msgSearch"),
        icon: (0, $cFTyZ.PrimeIcons).SEARCH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: apiCustomers,
        globalFilter: globalFilter,
        globalFilterFields: [
            "id",
            "name",
            "email",
            "validTo",
            "validFrom"
        ],
        dataKey: "id",
        sortField: "id",
        paginator: true,
        sortOrder: 1,
        loading: isLoading,
        rows: 20,
        emptyMessage: text("msgNoAvailableData")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "id",
        header: text("lblId"),
        sortable: true,
        style: {
            width: "3rem"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "status",
        header: text("lblStatus"),
        body: (apiCustomer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, apiCustomer.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("i", {
                className: "pi pi-circle-fill text-green-500"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("i", {
                className: "pi pi-circle-fill text-red-300"
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "name",
        header: text("lblName"),
        sortable: true,
        style: {
            width: "10rem",
            wordBreak: "break-word"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "validFrom",
        header: text("lblValidFrom"),
        body: (apiCustomer)=>new Date((0, $8N7S6.dateLocalize)(apiCustomer.validFrom)).toLocaleDateString("sv-SE"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "validTo",
        header: text("lblValidTo"),
        body: (apiCustomer)=>new Date((0, $8N7S6.dateLocalize)(apiCustomer.validTo)).toLocaleDateString("sv-SE"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "email",
        header: text("lblEmail"),
        sortable: true,
        style: {
            width: "20rem",
            wordBreak: "break-word"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "callBack",
        header: text("lblCallback"),
        body: (apiCustomer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, apiCustomer.callbackEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("i", {
                className: "pi pi-check-square text-green-500",
                title: "true"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("i", {
                className: "pi pi-minus-circle text-red-300",
                title: "false"
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (apiCustomer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
                className: "flex gap-3"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                rounded: true,
                severity: "info",
                outlined: true,
                icon: "pi pi-pencil",
                "data-testid": "edit-icon",
                title: text("btnEdit"),
                onClick: ()=>openApiCustomer(apiCustomer)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                "data-testid": "delete-icon",
                size: "small",
                icon: "pi pi-trash",
                rounded: true,
                outlined: true,
                title: text("btnDelete"),
                severity: "danger",
                onClick: ()=>deleteCustomer(apiCustomer)
            }))
    })));
});





var $fvmYM = parcelRequire("fvmYM");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $hJq0b = parcelRequire("hJq0b");

var $cbVaW = parcelRequire("cbVaW");

var $7Ilk7 = parcelRequire("7Ilk7");

var $akcQ4 = parcelRequire("akcQ4");

var $3rsxD = parcelRequire("3rsxD");

var $8gLAc = parcelRequire("8gLAc");

var $aL1Vp = parcelRequire("aL1Vp");

var $fvmYM = parcelRequire("fvmYM");

var $aodd6 = parcelRequire("aodd6");

var $8c5Kf = parcelRequire("8c5Kf");

var $8ugaX = parcelRequire("8ugaX");

var $aHJk3 = parcelRequire("aHJk3");

var $8N7S6 = parcelRequire("8N7S6");

var $f7UZA = parcelRequire("f7UZA");

var $iktXR = parcelRequire("iktXR");

var $9jM6q = parcelRequire("9jM6q");

var $4CNFe = parcelRequire("4CNFe");
const $9a3d8c4b2b698b8b$var$STooltip = (0, $akcQ4.default).div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 5px;
`;
const $9a3d8c4b2b698b8b$var$calculateValidityPeriod = (from, to)=>{
    if (!from || !to) return "custom";
    const dateFrom = new Date(from);
    const nonCustomYearOptions = [
        1,
        2,
        3
    ];
    const nonCustomDateDictionary = {};
    nonCustomYearOptions.forEach((n)=>{
        nonCustomDateDictionary[(0, $3rsxD.default)(dateFrom, n).toDateString()] = n * 12;
    });
    return nonCustomDateDictionary[new Date(to).toDateString()] ?? "custom";
};
const $9a3d8c4b2b698b8b$export$1793a4f2995b903d = ({ isOpened: isOpened, apiCustomer: apiCustomer, onCancel: onCancel, onCreate: onCreate, className: className, style: style })=>{
    const text = (0, $aL1Vp.default)();
    const validityPeriodOptions = [
        {
            key: "12",
            value: text("lblTwelveMonthsValidityInterval")
        },
        {
            key: "24",
            value: text("lblTwentyFourMonthsValidityInterval")
        },
        {
            key: "36",
            value: text("lblThirtySixMonthsValidityInterval")
        },
        {
            key: "custom",
            value: text("lblCustomValidityInterval")
        }
    ];
    const validFrom = new Date();
    const [generateApiKey, { data: apiHashKey }] = (0, $fvmYM.useLazyApiCustomerGetHashedApiKeyQuery)();
    const [isPrivateCustomer, setIsPrivateCustomer] = (0, $6uMv9.useState)(false);
    const [apiCallbackEnabled, setApiCAllbackEnabled] = (0, $6uMv9.useState)(false);
    (0, $4CNFe.default)({
        onEscapePress: onCancel
    });
    const schema = $7Ilk7.object().shape({
        name: $7Ilk7.string().required(text("msgNameRequired")),
        apiKey: $7Ilk7.string().required(text("msgApiKeyIsRequired")),
        email: $7Ilk7.string().required(text("msgEmailIsRequired")).typeError(text("msgEmailIsRequired")).email(text("msgEmailInvalid")),
        validTo: $7Ilk7.string().required(text("msgValidateToDateRequired")),
        callbackBaseUrl: $7Ilk7.string().nullable().when("$apiCallbackEnabled", (apiCallbackEnabled, schema)=>!apiCallbackEnabled ? schema : schema.nullable().typeError(text("msgCallbackBaseUrlRequired")).required(text("msgCallbackBaseUrlRequired")).url(text("msgCallbackBaseUrlInvalid"))),
        description: $7Ilk7.string().typeError(text("msgCompanyNameRequired")).required(text("msgCompanyNameRequired"))
    });
    const { register: register, handleSubmit: handleSubmit, watch: watch, reset: reset, setValue: setValue, trigger: trigger, formState: { errors: errors, isSubmitting: isSubmitting, isDirty: isDirty, isValid: isValid } } = (0, $cbVaW.useForm)({
        resolver: (0, $hJq0b.yupResolver)(schema, {
            abortEarly: false
        }),
        values: {
            ...apiCustomer,
            validFrom: apiCustomer ? new Date((0, $8N7S6.dateLocalize)(apiCustomer?.validFrom)).toLocaleDateString("sv-SE") : validFrom.toLocaleDateString("sv-SE"),
            validTo: new Date((0, $8N7S6.dateLocalize)(apiCustomer?.validTo)).toLocaleDateString("sv-SE"),
            validityPeriod: apiCustomer ? $9a3d8c4b2b698b8b$var$calculateValidityPeriod(apiCustomer.validFrom, apiCustomer.validTo) : "36",
            callbackEnabled: apiCustomer?.callbackEnabled ?? false
        },
        mode: "all",
        reValidateMode: "onChange",
        context: {
            apiCallbackEnabled: apiCallbackEnabled
        }
    });
    (0, $6uMv9.useEffect)(()=>{
        if (apiCustomer) {
            trigger();
            setApiCAllbackEnabled(apiCustomer?.callbackEnabled ?? false);
            setIsPrivateCustomer(apiCustomer.description === text("msgPrivateDescription"));
        }
    }, [
        apiCustomer
    ]);
    (0, $6uMv9.useEffect)(()=>{
        if (apiHashKey) setValue("apiKey", apiHashKey?.key, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: true
        });
    }, [
        apiHashKey
    ]);
    (0, $6uMv9.useEffect)(()=>{
        trigger("callbackBaseUrl");
    }, [
        trigger,
        apiCallbackEnabled
    ]);
    const watchValidityPeriod = watch("validityPeriod");
    const onSubmit = (data)=>{
        let validTo = new Date();
        if (data.validTo && data.validityPeriod === "custom") validTo = new Date(data.validTo);
        else validTo.setMonth(validFrom.getMonth() + parseInt(data.validityPeriod ?? "0", 10));
        onCreate({
            ...data,
            description: isPrivateCustomer ? text("msgPrivateDescription") : data.description,
            validFrom: validFrom.toDateString(),
            validTo: validTo.toDateString(),
            callbackEnabled: apiCallbackEnabled,
            enabled: true
        });
    };
    const handleGenerateApiKey = async ()=>{
        await generateApiKey();
    };
    return isOpened ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        "data-testid": "layout-container",
        title: apiCustomer ? text("lblEAPICustomerDetails", {
            name: apiCustomer.name
        }) : text("lblNewEAPICustomer"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        size: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group col-sm-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9jM6q.CheckboxInput), {
        checked: isPrivateCustomer,
        setChecked: (checked)=>setIsPrivateCustomer(()=>{
                setValue("description", checked ? text("msgPrivateDescription") : null, {
                    shouldDirty: true,
                    shouldValidate: true
                });
                return checked;
            }),
        dataTestId: "modal-form-checkbox",
        label: text("msgPrivateCustomer")
    }))), !isPrivateCustomer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group col-sm-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9a3d8c4b2b698b8b$var$STooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8c5Kf.InfoIcon), {
        title: text("msgCompanyNameIsRequiredTooltip"),
        size: 20
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        ...register("description"),
        labelText: text("lblOrganisationDescription"),
        id: "modal-form-description",
        "data-testid": "modal-form-description",
        type: "text",
        error: errors.description?.message,
        required: true
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-form margin-top-xsmall",
        "data-testid": "modal-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9a3d8c4b2b698b8b$var$STooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8c5Kf.InfoIcon), {
        title: text("msgNameIsRequiredTooltip"),
        size: 20
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        ...register("name"),
        labelText: text("lblNameField"),
        id: "modal-form-name",
        "data-testid": "modal-form-name",
        type: "text",
        error: errors.name?.message,
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9a3d8c4b2b698b8b$var$STooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8c5Kf.InfoIcon), {
        title: text("msgEmailIsRequiredTooltip"),
        size: 20
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        ...register("email"),
        id: "modal-form-email",
        labelText: text("lblEmailField"),
        type: "text",
        "data-testid": "modal-form-email",
        error: errors.email?.message,
        required: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group margin-top-xsmall",
        "data-testid": "modal-form-api-key"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-sm-6 margin-top-25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        ...register("apiKey"),
        id: "modal-input-apikey",
        "data-testid": "modal-input-apikey",
        labelText: text("lblApiKey"),
        error: errors.apiKey?.message,
        required: true,
        disabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        type: "button",
        "data-testid": "modal-button-generate",
        onClick: handleGenerateApiKey,
        primary: true,
        className: "margin-top-xsmall",
        label: text("btnGenerate")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-sm-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($9a3d8c4b2b698b8b$var$STooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8c5Kf.InfoIcon), {
        title: text("validityPeriodIsRequiredTooltip"),
        size: 20
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aodd6.default), {
        ...register("validityPeriod"),
        "data-testid": "validity-period-select",
        options: validityPeriodOptions
    })))), watchValidityPeriod && watchValidityPeriod === "custom" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-form margin-top-med",
        "data-testid": "modal-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8ugaX.default), {
        ...register("validFrom"),
        "data-testid": "valid-from-input",
        id: "creationDate",
        disabled: true,
        defaultValue: validFrom.toLocaleDateString("sv-SE"),
        labelText: text("lblFromField")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8ugaX.default), {
        ...register("validTo"),
        "data-testid": "valid-to-input",
        id: "expireDate",
        min: validFrom.toLocaleDateString("se-SE"),
        error: errors.validTo?.message,
        labelText: text("lblToField")
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group margin-top-xsmall checkbox-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("dt", {
        className: "margin-right-small"
    }, text("lblApiCallback"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aHJk3.default), {
        "data-testid": "api-callback-toggle",
        isToggled: apiCallbackEnabled,
        toggleFn: ()=>{
            setApiCAllbackEnabled((value)=>{
                setValue("callbackEnabled", !value, {
                    shouldValidate: true,
                    shouldDirty: true
                });
                return !value;
            });
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group margin-top-xsmall margin-bottom-med"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        ...register("callbackBaseUrl"),
        "data-testid": "modal-input-callback-base-url",
        id: "modal-input-callback-base-url",
        type: "text",
        labelText: text("lblCallbackBaseUrl"),
        required: true,
        disabled: !apiCallbackEnabled,
        error: errors.callbackBaseUrl?.message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-footer margin-top-med",
        "data-testid": "modal-footer-buttons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        primary: false,
        label: text("btnCancel"),
        type: "button",
        "data-testid": "modal-cancel-button",
        onClick: ()=>{
            reset();
            onCancel();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        primary: true,
        label: text(apiCustomer ? "btnSave" : "btnCreate"),
        disabled: !isDirty || isSubmitting || !isValid,
        type: "submit",
        "data-testid": "modal-submit-button"
    })))) : null;
};



var $2460e = parcelRequire("2460e");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $8gLAc = parcelRequire("8gLAc");

var $aL1Vp = parcelRequire("aL1Vp");

var $fvmYM = parcelRequire("fvmYM");

var $1xw2Y = parcelRequire("1xw2Y");

var $2460e = parcelRequire("2460e");

var $f7UZA = parcelRequire("f7UZA");

var $4CNFe = parcelRequire("4CNFe");
const $cefce4524e8bde79$var$ModalSubHeading = (0, $akcQ4.default).div`
    font-weight: 300;
    font-size: 14px;
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    margin: 6px 0px 7px 0px;
`;
const $cefce4524e8bde79$var$ConfirmationText = (0, $akcQ4.default).div`
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme: theme })=>theme.font.darkestColor};
    margin-top: 20px;
    margin-bottom: 20px;
`;
const $cefce4524e8bde79$var$ModalSubText = (0, $akcQ4.default).div`
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme: theme })=>theme.font.darkestColor};
    margin-bottom: 20px;
`;
const $cefce4524e8bde79$var$ModalContent = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
`;
const $cefce4524e8bde79$var$ModalListContainer = (0, $akcQ4.default).div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
`;
const $cefce4524e8bde79$var$ModalListItem = (0, $akcQ4.default).a`
    & {
        color: ${({ theme: theme })=>theme.font.darkestColor};
        text-decoration: underline;
        font-size: 14px;
        margin: 5px;
    }

    &:hover {
        color: ${({ theme: theme })=>theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme: theme })=>theme.font.midDarkColor};
    }
`;
const $cefce4524e8bde79$export$5f0f1194656af2e7 = /*#__PURE__*/ (0, $6uMv9.memo)(function DeleteExternalServerModal({ className: className, apiCustomer: apiCustomer, onCancel: onCancel, isOpened: isOpened, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [removeCustomer] = (0, $fvmYM.useApiCustomerDeleteMutation)();
    const { data: chargePoints, isFetching: dataLoading, isLoading: isLoading } = (0, $fvmYM.useApiCustomerGetChargePointsQuery)({
        apiCustomerId: apiCustomer.id ?? 0
    }, {
        skip: !apiCustomer.id
    });
    const handleRemoveApiCustomer = async ()=>{
        if (apiCustomer && apiCustomer.id) await removeCustomer({
            apiCustomerId: apiCustomer.id
        }).unwrap().then(()=>{
            onCancel();
            (0, $2460e.notifySuccess)(text("msgDeleteApiCustomerSuccess"));
        }).catch(()=>{
            onCancel();
            (0, $2460e.notifyError)(text("msgDeleteApiCustomerError"));
        });
    };
    (0, $4CNFe.default)({
        onEnterPress: ()=>{
            if (!chargePoints || chargePoints?.length === 0) handleRemoveApiCustomer();
        },
        onEscapePress: onCancel
    });
    return isOpened ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblCustomerDeleteModal"),
        titleClassName: "modal-header text-center",
        size: "md",
        "data-testid": "delete-modal"
    }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, chargePoints && chargePoints?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalContent, {
        "data-testid": "chargers-list-to-server"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalSubText, {
        "data-testid": "chargers-list-to-server-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgChargersConnectedToApiCustomer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalSubHeading, {
        "data-testid": "chargers-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblChargersffected"
    }), dataLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        "data-testid": "chargers-list-loading",
        className: "fa fa-spinner fa-pulse"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalListContainer, null, chargePoints?.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalListItem, {
            as: (0, $iZaUM.Link),
            key: chargePoint,
            to: `/chargepoints/${chargePoint}`,
            target: "_blank",
            "data-testid": `chargePoints-${chargePoint}`
        }, chargePoint)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ConfirmationText, {
        "data-testid": "confirmation-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblProceedConfirmation"
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "fa fa-spinner fa-pulse"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalContent, {
        "data-testid": "api-customer-name-url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalSubHeading, {
        "data-testid": "api-name-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblApiName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalSubText, {
        "data-testid": "api-name-text"
    }, apiCustomer.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalSubHeading, {
        "data-testid": "callback-text-url-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblApiCallbackUrl"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cefce4524e8bde79$var$ModalSubText, {
        "data-testid": "callback-text-url-text"
    }, apiCustomer.callbackBaseUrl ?? "---")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-footer margin-top-med",
        "data-testid": "modal-footer-buttons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        primary: false,
        label: text("btnCancel"),
        type: "button",
        "data-testid": "modal-cancel-button",
        minWidth: "150px",
        onClick: onCancel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        primary: true,
        disabled: chargePoints && chargePoints?.length > 0,
        type: "button",
        label: text("btnYes"),
        minWidth: "150px",
        "data-testid": "modal-submit-button",
        onClick: handleRemoveApiCustomer
    }))) : null;
});





var $QoO6n = parcelRequire("QoO6n");

var $aL1Vp = parcelRequire("aL1Vp");
const $8e37a3025fe6b9ce$export$372ef05b05f014e5 = ()=>{
    const text = (0, $aL1Vp.default)();
    const { data: apiCustomers = [], isFetching: isFetching, refetch: refetch } = (0, $fvmYM.useApiCustomerGetAllQuery)({});
    const [createApiCustomer] = (0, $fvmYM.useApiCustomerCreateMutation)();
    const [updateApiCustomer] = (0, $fvmYM.useApiCustomerUpdateMutation)();
    const [createApiCustomersModalIsOpened, setCreateApiCustomersModalIsOpened] = (0, $6uMv9.useState)(false);
    const [removeApiCustomersModalIsOpened, setRemoveApiCustomersModalIsOpened] = (0, $6uMv9.useState)(false);
    const [apiCustomer, setApiCustomer] = (0, $6uMv9.useState)(undefined);
    const handleCreateApiCustomer = async (apiCustomer)=>{
        if (apiCustomer.id) await updateApiCustomer({
            apiCustomer: apiCustomer
        }).unwrap().then(()=>{
            setCreateApiCustomersModalIsOpened(false);
            refetch();
            (0, $2460e.notifySuccess)(text("msgUpdateApiCustomerSuccess"));
        }).catch(()=>{
            (0, $2460e.notifyError)(text("msgUpdateApiCustomerError"));
        });
        else await createApiCustomer({
            apiCustomer: apiCustomer
        }).unwrap().then(()=>{
            setCreateApiCustomersModalIsOpened(false);
            refetch();
            (0, $2460e.notifySuccess)(text("msgCreateApiCustomerSuccess"));
        }).catch(()=>{
            (0, $2460e.notifyError)(text("msgCreateApiCustomerError"));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $QoO6n.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $5b998e337471b659$export$87201ebaf33a7a54), {
        apiCustomers: apiCustomers,
        openApiCustomer: (ac)=>{
            setApiCustomer(ac);
            setCreateApiCustomersModalIsOpened(true);
        },
        deleteCustomer: (ac)=>{
            setApiCustomer(ac);
            setRemoveApiCustomersModalIsOpened(true);
        },
        isLoading: isFetching
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9a3d8c4b2b698b8b$export$1793a4f2995b903d), {
        key: `create-modal-key-${createApiCustomersModalIsOpened}`,
        isOpened: createApiCustomersModalIsOpened,
        onCancel: ()=>{
            setCreateApiCustomersModalIsOpened(false);
            setApiCustomer(undefined);
        },
        apiCustomer: apiCustomer,
        onCreate: handleCreateApiCustomer
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cefce4524e8bde79$export$5f0f1194656af2e7), {
        key: `delete-modal-key-${removeApiCustomersModalIsOpened}`,
        isOpened: removeApiCustomersModalIsOpened,
        apiCustomer: apiCustomer ?? {},
        onCancel: ()=>{
            refetch();
            setRemoveApiCustomersModalIsOpened(false);
            setApiCustomer(undefined);
        }
    }));
};





var $6uMv9 = parcelRequire("6uMv9");

var $QoO6n = parcelRequire("QoO6n");

var $3YfCm = parcelRequire("3YfCm");

var $aL1Vp = parcelRequire("aL1Vp");

var $f7UZA = parcelRequire("f7UZA");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $cbVaW = parcelRequire("cbVaW");

var $akcQ4 = parcelRequire("akcQ4");

var $iIdvQ = parcelRequire("iIdvQ");

var $iktXR = parcelRequire("iktXR");

var $2460e = parcelRequire("2460e");

var $4CNFe = parcelRequire("4CNFe");

var $4AFFH = parcelRequire("4AFFH");

var $fvmYM = parcelRequire("fvmYM");

var $8gLAc = parcelRequire("8gLAc");

var $1xw2Y = parcelRequire("1xw2Y");

var $2JPeY = parcelRequire("2JPeY");

var $aL1Vp = parcelRequire("aL1Vp");

var $f7UZA = parcelRequire("f7UZA");
const $2f5bc372bb9980a7$export$81122323e69f0e7c = (0, $akcQ4.default).div`
    width: 100%;
    overflow: auto;
    max-height: 300px;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
        display: none;
    }
`;
const $2f5bc372bb9980a7$export$af64824451fbc2f8 = (0, $akcQ4.default).div`
    color: ${({ theme: theme })=>theme.font.darkestColor};
    font-weight: 500;
    font-size: 15px;
    margin: 5px 0px 18px 0px;
`;
const $2f5bc372bb9980a7$export$8ddb2c50209aec10 = /*#__PURE__*/ (0, $6uMv9.memo)(function ExternalServerCreateModal({ className: className, closeModal: closeModal, externalServerData: externalServerData, externalServer: externalServer, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [addedPartners, setAddedPartners] = (0, $6uMv9.useState)([]);
    const [isPartnerListChanged, setIsPartnerListChanged] = (0, $6uMv9.useState)(false);
    const { register: register, getValues: getValues, formState: { errors: errors, isValid: isValid } } = (0, $cbVaW.useForm)({
        mode: "all"
    });
    const isNameExists = (name)=>{
        const nameExists = externalServerData?.some((item)=>item?.description === name);
        return nameExists ? text("lblCpmsNameDuplicateError") : undefined;
    };
    const isUrlExists = (url)=>{
        const urlExists = externalServerData?.some((item)=>item?.url === url);
        return urlExists ? text("lblCpmsUrlDuplicate") : undefined;
    };
    const { data: selectedPartners, isLoading: loadingPartners } = (0, $fvmYM.useExternalServerGetPartnersQuery)({
        externalServerId: externalServer?.id
    }, {
        skip: !externalServer || !externalServer.id
    });
    const [createNewExternalServer] = (0, $fvmYM.useExternalServerCreateMutation)();
    const [addPartner] = (0, $fvmYM.useExternalServerUpdatePartnerConnectionsMutation)({});
    const { data: allPartners } = (0, $fvmYM.usePartnerGetAllAllQuery)({
        excludeOrphans: true
    });
    const partners = (0, $6uMv9.useMemo)(()=>{
        if (allPartners) return new Map(allPartners?.map((partner)=>[
                partner.id,
                partner
            ]));
    }, [
        allPartners
    ]);
    (0, $6uMv9.useEffect)(()=>{
        if (loadingPartners) return;
        const preAddedPartners = selectedPartners?.map((obj)=>obj.id) ?? [];
        setAddedPartners(preAddedPartners);
    }, [
        selectedPartners
    ]);
    const doAddNewUrl = async ()=>{
        try {
            const response = await createNewExternalServer({
                externalServer: getValues()
            }).unwrap();
            const serverId = response?.id;
            if (serverId && addedPartners) await addPartner({
                externalServerId: serverId,
                body: addedPartners
            }).unwrap();
            (0, $2460e.notifySuccess)(text("lblServerCreated"));
            closeModal();
        } catch (e) {
            (0, $2460e.notifyError)(text("lblServerCreateError"));
        }
    };
    const doEditPartner = async ()=>{
        try {
            if (externalServer?.id) await addPartner({
                externalServerId: externalServer?.id,
                body: addedPartners
            }).unwrap();
            (0, $2460e.notifySuccess)(text("lblPartnerAssigned"));
            closeModal();
        } catch (e) {
            (0, $2460e.notifyError)(text("lblPartnerAssignFailed"));
        }
    };
    const partnerOptions = allPartners ? allPartners?.filter((partner)=>!addedPartners?.includes(partner?.id)).map((data)=>({
            value: data?.id || "",
            label: `${data?.name} - ${data?.email}` || ""
        })) : [];
    const handleRemove = (valueToRemove)=>{
        const tempPartners = addedPartners.filter((partner)=>partner !== valueToRemove);
        setAddedPartners(tempPartners);
        setIsPartnerListChanged(true);
    };
    const handleAdd = (optionToAdd)=>{
        const tempPartners = [
            ...addedPartners,
            optionToAdd
        ];
        setAddedPartners(tempPartners);
        setIsPartnerListChanged(true);
    };
    (0, $4CNFe.default)({
        onEnterPress: ()=>{
            isPartnerListChanged && externalServer ? doEditPartner() : doAddNewUrl();
        },
        onEscapePress: closeModal
    });
    const sortPartnerNames = (prevPartnerId, nextPartnerId)=>{
        if (partners) {
            const prevPartnerName = partners.get(prevPartnerId)?.name ?? "";
            const nextPartnerName = partners.get(nextPartnerId)?.name ?? "";
            return prevPartnerName.localeCompare(nextPartnerName, undefined, {
                numeric: true,
                sensitivity: "base"
            });
        }
        return 0;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        "data-testid": "create-modal",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: externalServer ? text("lblEditExternalServerModalWidget") : text("lblCreateExternalServerModalWidget"),
        size: "lg",
        actions: [
            {
                btn: "btn-secondary",
                callback: closeModal,
                label: text("btnCancel")
            },
            {
                callback: externalServer ? doEditPartner : doAddNewUrl,
                disabled: externalServer ? !isPartnerListChanged : !isValid,
                label: text("btnSave")
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        "data-testid": "create-modal-form",
        autoComplete: "off"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        labelText: text("lblCpmsName"),
        ...register("description", {
            required: {
                value: true,
                message: text("lblCpmsNameRequired")
            },
            maxLength: {
                value: 50,
                message: text("lblNameError")
            },
            validate: {
                nameExists: isNameExists
            }
        }),
        id: "name",
        defaultValue: externalServer ? externalServer?.description : "",
        error: externalServer ? "" : errors.description?.message,
        subtitle: externalServer ? "" : text("lblCpmsNameInfoText"),
        className: "noBorder-input",
        "data-testid": "name-input",
        required: true,
        readonly: externalServer ? true : false
    }), !externalServer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "margin-top-med "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        labelText: text("lblCpmsUrl"),
        id: "cpms-url",
        ...register("url", {
            required: {
                value: true,
                message: text("lblCpmsUrlRequired")
            },
            pattern: {
                value: /^(ws|wss):\/\/[^\s/$.?#][^\s]*[^\s$.?#/](\/)$/i,
                message: text("lblCpmsUrlInvalidText")
            },
            validate: {
                urlExists: isUrlExists
            }
        }),
        error: errors?.url?.message,
        subtitle: externalServer ? "" : text("lblCpmsUrlInfoText"),
        className: "noBorder-input",
        autoComplete: "off",
        "data-testid": "url-input",
        required: true
    })), externalServer?.initialAuthorizationKey || !externalServer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "margin-top-med "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "cpms-auth-key",
        labelText: text("lblPassword"),
        ...register("initialAuthorizationKey"),
        defaultValue: externalServer ? externalServer?.initialAuthorizationKey : "",
        className: "noBorder-input password",
        "data-testid": "password-input",
        type: "password",
        autoComplete: "new-password",
        readonly: externalServer ? true : false
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "margin-top-med "
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iIdvQ.Combobox), {
        id: "select-partner",
        labelText: text("lblSelectPartner"),
        options: partnerOptions,
        onChange: (option)=>handleAdd(option.value),
        enableDefaultOption: false
    })))), addedPartners && addedPartners.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "margin-top-med"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($2f5bc372bb9980a7$export$81122323e69f0e7c, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableHead), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAssignedPartners"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableHead), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmail"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableHead), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableBody), null, addedPartners.sort(sortPartnerNames).map((key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableRow), {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableCell), null, partners?.get(key)?.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableCell), null, partners?.get(key)?.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2JPeY.STableCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            className: "transparent-btn",
            onClick: ()=>{
                handleRemove(key);
            },
            "data-testid": "remove-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4AFFH.CloseIcon), null))))))))));
});





var $1xw2Y = parcelRequire("1xw2Y");

var $fvmYM = parcelRequire("fvmYM");

var $35vY7 = parcelRequire("35vY7");

var $cBlPU = parcelRequire("cBlPU");
parcelRequire("acee3");
var $6IEar = parcelRequire("6IEar");

var $2naDF = parcelRequire("2naDF");

var $dXUkh = parcelRequire("dXUkh");

var $174na = parcelRequire("174na");

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $2460e = parcelRequire("2460e");

var $4CNFe = parcelRequire("4CNFe");

var $fvmYM = parcelRequire("fvmYM");

var $aL1Vp = parcelRequire("aL1Vp");

var $8gLAc = parcelRequire("8gLAc");

var $1xw2Y = parcelRequire("1xw2Y");

var $4AFFH = parcelRequire("4AFFH");

var $hXjVB = parcelRequire("hXjVB");

var $cItjU = parcelRequire("cItjU");
const $627a7fe40e10434d$var$ModalSubHeading = (0, $akcQ4.default).div`
    font-weight: 300;
    font-size: 14px;
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    margin: 4px 0px 4px 0px;
`;
const $627a7fe40e10434d$export$12e298e8f2d60c80 = (0, $akcQ4.default).div`
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme: theme })=>theme.font.darkestColor};
    margin-bottom: 8px;
`;
const $627a7fe40e10434d$export$69cc54976168bd41 = (0, $akcQ4.default).div`
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme: theme })=>theme.font.darkestColor};
    margin-bottom: 4px;
    display: flex;
    gap: 4px;
    align-items: center;
    a {
        padding: 4px;
        &:hover {
            cursor: pointer;
            background-color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
        }
        &:focus {
            background-color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
        }
    }

    button {
        background: transparent;
        padding: 4px;
        border: none;
        &:hover {
            cursor: pointer;
            background-color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
        }
        &:focus {
            background-color: ${({ theme: theme })=>theme.brandColors.CA_Light_Gray};
        }
    }
`;
const $627a7fe40e10434d$export$6da19a24bf249f17 = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-x: hidden;
`;
const $627a7fe40e10434d$export$665a2b3de6976335 = (0, $akcQ4.default).div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
`;
const $627a7fe40e10434d$export$3fc974409d6ff3e5 = (0, $akcQ4.default).a`
    & {
        color: ${({ theme: theme })=>theme.font.darkestColor};
        text-decoration: underline;
        font-size: 14px;
        margin: 4px;
    }

    &:hover {
        color: ${({ theme: theme })=>theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme: theme })=>theme.font.midDarkColor};
    }
`;
const $627a7fe40e10434d$export$7f1b04d67541f4d1 = /*#__PURE__*/ (0, $6uMv9.memo)(function DeleteExternalServerModal({ className: className, externalServer: externalServer, closeModal: closeModal, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [deleteExternalServer] = (0, $fvmYM.useExternalServerDeleteMutation)();
    const externalServerId = (externalServer && externalServer.id) ?? 0;
    const { data: getPartners } = (0, $fvmYM.useExternalServerGetPartnersQuery)({
        externalServerId: externalServer?.id
    });
    const [addPartner] = (0, $fvmYM.useExternalServerUpdatePartnerConnectionsMutation)({});
    const [partners, setPartners] = (0, $6uMv9.useState)([]);
    (0, $6uMv9.useEffect)(()=>setPartners(getPartners), [
        getPartners
    ]);
    const { data: chargePoints, isFetching: dataLoading, isLoading: isLoading } = (0, $fvmYM.useExternalServerGetChargePointsQuery)({
        externalServerId: externalServerId
    }, {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });
    const disabledYesButton = chargePoints && chargePoints?.length > 0 || partners && partners?.length > 0 || chargePoints && chargePoints?.length > 0 && partners && partners?.length == 0;
    /* Delete server */ const deleteServer = async ()=>{
        if (externalServerId) try {
            await addPartner({
                externalServerId: externalServer?.id,
                body: partners
            }).unwrap();
            await deleteExternalServer({
                externalServerId: externalServerId
            }).unwrap();
            (0, $2460e.notifySuccess)(text("lblServerDeleted"));
            closeModal();
        } catch (e) {
            closeModal();
            (0, $2460e.notifyError)(text("lblServerDeleteError"));
        }
    };
    /* ----- */ (0, $4CNFe.default)({
        onEnterPress: ()=>{
            if (!chargePoints || chargePoints?.length === 0) deleteServer();
        },
        onEscapePress: closeModal
    });
    const handleRemove = (valueToRemove)=>{
        const tempPartners = partners?.filter((partner)=>partner?.id !== valueToRemove);
        setPartners(tempPartners);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblServerDeleteModal"),
        titleClassName: "modal-header text-center",
        size: "lg",
        "data-testid": "delete-modal",
        actions: [
            {
                btn: "btn-secondary",
                callback: closeModal,
                label: text("btnCancel")
            },
            {
                callback: deleteServer,
                disabled: disabledYesButton,
                label: text("btnYes")
            }
        ]
    }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$6da19a24bf249f17, {
        "data-testid": "cpms-name-url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$var$ModalSubHeading, {
        "data-testid": "cpms-name-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblCpmsName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$12e298e8f2d60c80, {
        "data-testid": "cpms-name-text"
    }, externalServer?.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$var$ModalSubHeading, {
        "data-testid": "cpms-url-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblCpmsUrl"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$12e298e8f2d60c80, {
        "data-testid": "cpms-url-text"
    }, externalServer?.url)), chargePoints && chargePoints?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$6da19a24bf249f17, {
        "data-testid": "chargers-list-to-server"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cItjU.default), {
        alertType: (0, $cItjU.AlertType).Warning,
        "data-testid": "chargers-list-to-server-text",
        text: text("lblChargersConnectedToSever")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$var$ModalSubHeading, {
        "data-testid": "chargers-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblChargersffected"
    }), dataLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        "data-testid": "chargers-list-loading",
        className: "fa fa-spinner fa-pulse"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$665a2b3de6976335, null, chargePoints?.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$69cc54976168bd41, {
            key: chargePoint
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
            className: "margin-top-2"
        }, chargePoint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            to: `/chargepoints/${chargePoint}`,
            "data-testid": `link-charge-point-${chargePoint}`,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $hXjVB.GoToIcon), {
            size: 13
        })))))), partners && partners?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$6da19a24bf249f17, {
        "data-testid": "partners-list-to-server"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cItjU.default), {
        "data-testid": "PartnersConnectedToServer",
        alertType: (0, $cItjU.AlertType).Warning,
        text: text("lblPartnersConnectedToServer")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$var$ModalSubHeading, {
        "data-testid": "cpms-partner-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAssignedPartners"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$665a2b3de6976335, null, partners?.map((partner)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($627a7fe40e10434d$export$69cc54976168bd41, {
            "data-testid": "cpms-assigned-partner"
        }, partner?.name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            className: "margin-top-2",
            "data-testid": "btn-remove-partner",
            onClick: ()=>{
                handleRemove(partner?.id);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4AFFH.CloseIcon), {
            size: 13
        }))))))))));
});





var $8c5Kf = parcelRequire("8c5Kf");

var $3BMWV = parcelRequire("3BMWV");

var $lG0u6 = parcelRequire("lG0u6");
const $94e803894e1ed768$export$1e5b60524e0a7843 = ()=>{
    const text = (0, $aL1Vp.default)();
    const [createModal, setCreateModal] = (0, $6uMv9.useState)(false);
    const [deleteModal, setDeleteModal] = (0, $6uMv9.useState)(false);
    const [externalServer, setExternalServer] = (0, $6uMv9.useState)();
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [searchValue, setSearchValue] = (0, $6uMv9.useState)("");
    const [pageSize, setPageSize] = (0, $6uMv9.useState)(20);
    const offset = currentPage * pageSize;
    const filtersContainerRef = (0, $6uMv9.useRef)(null);
    const handlePageClick = (selected)=>{
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0);
        setCurrentPage(selected);
    };
    const closeModal = ()=>{
        setCreateModal(false);
        setExternalServer(undefined);
    };
    const closeDeleteModal = ()=>{
        setDeleteModal(false);
        setExternalServer(undefined);
    };
    const { data: externalServerData, isLoading: dataLoading } = (0, $fvmYM.useExternalServerGetAllQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $QoO6n.default), {
        "data-testid": "external-server-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-md-12 col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "external-server-widget",
        title: text("lblProxyRelayWidget"),
        headerInfoIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "margin-top-6"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3BMWV.default), {
            content: "lblProxyRelayInfoText",
            className: "large-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8c5Kf.InfoIcon), {
            size: 18,
            fill: (0, $lG0u6.theme).brandColors.CA_Blue,
            id: "eapi-info-icon"
        }))),
        loadingStatus: dataLoading,
        headerButtons: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                label: text("btnCreate"),
                size: "sm",
                onClick: ()=>setCreateModal(true),
                "data-testid": "create-button"
            })
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-3 alpha margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        "data-testid": "search",
        type: "text",
        name: "search",
        maxLength: 1000,
        id: "search",
        value: searchValue,
        onChange: (event)=>setSearchValue(event.target.value),
        className: "form-control",
        placeholder: text("lblSearchField")
    })), externalServerData && externalServerData?.length > 20 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "text-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        "data-testid": "pagination-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgResultPage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, ":")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cBlPU.default), {
        value: pageSize,
        onChange: (value)=>{
            setPageSize(value), setCurrentPage(0);
        },
        "data-testid": "button-paginate-group"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "table-container",
        "data-testid": "server-list-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
        clickable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "name-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblCpmsName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "url-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblCpmsUrl"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "remove-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblRemove"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), {
        dataTestId: "server-list"
    }, externalServerData && externalServerData?.filter((server)=>(0, $6IEar.filterFieldsBySearchValue)([
            server?.description ?? undefined,
            server?.url ?? undefined
        ], searchValue)).slice(offset, offset + pageSize).map((server)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: server.id,
            clickable: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `name-${server?.description}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
            onClick: ()=>{
                if (!deleteModal) setCreateModal(true);
                setExternalServer(server);
            }
        }, server?.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `name-${server?.url}`
        }, server?.url), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            "data-testid": "remove-button",
            type: "button",
            className: "btn btn-danger btn-xs btn-icon margin-left-small",
            onClick: ()=>{
                setDeleteModal(true);
                setExternalServer(server);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "fa fa-remove"
        })))))))), externalServerData && externalServerData?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        "data-testid": "pagination",
        setPageIndex: handlePageClick,
        totalCount: externalServerData?.length,
        pageSize: pageSize,
        pageIndex: currentPage,
        displayedChargers: pageSize
    })))), createModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2f5bc372bb9980a7$export$8ddb2c50209aec10), {
        closeModal: closeModal,
        externalServerData: externalServerData,
        externalServer: externalServer
    }), deleteModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $627a7fe40e10434d$export$7f1b04d67541f4d1), {
        closeModal: closeDeleteModal,
        externalServer: externalServer
    }));
};





var $1oism = parcelRequire("1oism");

var $6uMv9 = parcelRequire("6uMv9");

var $cfan9 = parcelRequire("cfan9");

var $96Lrx = parcelRequire("96Lrx");

var $52Dbq = parcelRequire("52Dbq");

var $2akJT = parcelRequire("2akJT");

var $4MzD1 = parcelRequire("4MzD1");

var $aL1Vp = parcelRequire("aL1Vp");
const $1d2c5d3e11dc7fad$export$8ef6607f6150ee3c = ()=>{
    const text = (0, $aL1Vp.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cfan9.Card), {
        title: text("lblChangesOfChargingOperator")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2akJT.LazyTabView), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $96Lrx.TabPanel), {
        header: text("lblPendingRequests")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MzD1.CompanyTransfersWidget), null)))));
};




const $047f7201b60466b9$var$RequireAuth = ({ children: children })=>{
    const location = (0, $iZaUM.useLocation)();
    const token = (0, $4vH3e.useSelector)((state)=>state.token);
    const allowAccess = (0, $4vH3e.useSelector)((state)=>state.user.isSuperAdmin);
    return token && allowAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9ef02355ab30dae0$export$2e2bcd8739ae039), {
        className: "page-layout-header pt-5 pb-6 xl:pt-4 xl:pb-4"
    }), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Navigate), {
        to: "/login",
        state: {
            from: location.pathname
        },
        replace: true
    });
};
const $047f7201b60466b9$var$App = ()=>{
    const token = (0, $4vH3e.useSelector)((state)=>state.token);
    const location = (0, $iZaUM.useLocation)();
    (0, $6uMv9.useLayoutEffect)(()=>{
        // Scroll to the top of the page when the route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Routes), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "/*",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Navigate), {
            to: token ? "/dashboard" : "/login"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "login",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $73srW.SignInPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "dashboard",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $b33cd1fc52bb1ad5$export$fedd53519a0e2bce), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "companies",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $87feb99acb847344$export$8acabd3b657a454), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "operator-changes",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1d2c5d3e11dc7fad$export$8ef6607f6150ee3c), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "/company/:companyId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1fc61c8580c18e30$export$2954431ebbef887d), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "chargepoints",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $139337fb7b5014a6$export$662e7dca465a6887), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "chargepoints/:chargePointId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6675abd5d53207a0$export$201cc43952975304), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "partners",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $982e512e279efadd$export$10085bc1d6e24c50), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "partner/:id",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2cfd2106bedb9db9$export$4d779efee0ce2e52), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "loadbalancer",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8XNZy.LoadbalancerPage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "loadbalancer/:id",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2vwem.LoadBalancerDetailsWidgetPage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "measurementDevices",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $44408ddca77a08e8$export$8de4554fe05e44f8), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "measurementDevice/:deviceId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4yml8.MeasurementDevicePage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "users",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $c2d7899b92a23b6d$export$107317390f5aa598), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "eapi",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8e37a3025fe6b9ce$export$372ef05b05f014e5), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "firmware",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oism.default), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "externalservers",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($047f7201b60466b9$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $94e803894e1ed768$export$1e5b60524e0a7843), null))
    }));
};
var $047f7201b60466b9$export$2e2bcd8739ae039 = $047f7201b60466b9$var$App;


const $f90f76eb2ccd7001$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($fXJGT))).createRoot(document.getElementById("root"));
$f90f76eb2ccd7001$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dcOIZ.ThemeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6uMv9.Suspense), {
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iAZE5.LocalizationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4vH3e.Provider), {
    store: (0, $atMtE.store)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $edR9j.PersistGate), {
    loading: null,
    persistor: (0, $atMtE.persistor)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cFTyZ.PrimeReactProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3jZfA.ToastProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.BrowserRouter), {
    basename: "support"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $047f7201b60466b9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iQS7O.ConfirmDialog), {
    style: {
        width: "40vw"
    },
    breakpoints: {
        "1100px": "75vw",
        "960px": "100vw"
    }
}))))))))));


//# sourceMappingURL=index.f6a53d6a.js.map
